import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  ConfirmationService,
  MenuItem,
  MessageService,
  PrimeIcons,
} from "primeng/api";
import { NGXLogger } from "ngx-logger";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActivatedRoute, Router } from "@angular/router";
import { OdaAtFirestore } from "src/app/models/odaAtFirestore.model";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { environment } from "src/environments/environment";
import { onSnapshot } from "firebase/firestore";
import { UtilService } from "src/app/services/util.service";
import { Menu } from "primeng/menu";

import { ExcelService } from "src/app/services/excelService.service";
import {
  FiltroPratica,
  PraticaFlowdy2_Firestore,
} from "src/app/models/praticaFirestore.model";
import { StiliService } from "src/app/services/stili.service";
import { UserService } from "src/app/services/user.service";
import {
  deleteObject,
  getBlob,
  getMetadata,
  getStorage,
  listAll,
  ref,
} from "firebase/storage";
import { saveAs } from "file-saver";
import { PraticheService } from "src/app/services/pratiche.service";
import { DialogNoteReworkFase1 } from "../../shared/note-rework-fase1/note-rework.component";
import * as JSZip from "jszip";
import { ComunicaBocciatura } from "../../shared/comunica-bocciatura/comunica_bocciatura.component";
import { DialogAccettazioneInvioInfratel } from "../../shared/comunica-accettazione/accettazione.component";
import { Location } from "@angular/common";
import { Utente } from "src/app/models/utente.model";
import { OdaService } from "src/app/services/oda.service";
import { ListeService } from "src/app/services/liste.service";
import { StoricoPraticaComponent } from "../../shared/storico/storico-pratica.component";
import { DialogComunicaDataAppuntamentoFase2 } from "../../shared/data-appuntamento-fase2/data_appuntamento_fase2.component";
import { DialogComunicaEsitoAppuntamentoFase2 } from "../../shared/esito-appuntamento-fase2/esito_appuntamento_fase2.component";
import { DialogCaricaFoto } from "../../shared/carica-foto/carica-foto.component";
import { DialogNoteReworkFase2 } from "../../shared/note-rework-fase2/note-rework.component";
import { DialogInvioInfratel } from "../../shared/comunica-invio-infratel/invio-infratel.component";
import { DialogCaricaPermessoFase2 } from "../../shared/carica-permesso/carica-permesso_fase2.component";
import { v4 as uuidv4 } from "uuid";
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";
import { DialogPresidioTIMRifiutaPratica } from "../../shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component";
import { PosizioneScuola } from "../../shared/posizione-scuola/posizione-scuola.component";
import { PraticaScuola } from "src/app/models/pratica.scuola.model";
import { ScuolaDTO } from "src/app/models/scuola.model";
import { ScuoleService } from "src/app/services/scuole.service";
import { ModificaPratica } from "../../shared/modifica-pratica/modifica-pratica.component";
import { DialogModificaStatoPraticaBando1 } from "../../../scuola/bando1/pratiche-scuola-bando1.component";
import { DialogInformazioniFase3Bando2 } from "./inserisci-info/inserisci-info-fase3.component";
import { DialogCaricaPacchettoNT9 } from "../../shared/carica-NT9/carica-nt9.component";
import { DialogCaricaAltriFile } from "../../shared/carica-altri-file/carica-altri-file.component";
import { DialogVerificaConsegnaFase3 } from "../../shared/verifica-consegna-fase3/verifica_consegna_fase3.component";
import { ModificaCodiceinvio } from "../../shared/modifica-codice-invio/modifica-codice_invio.component";
import { CompletaFase3Bando2 } from "./completa-pratica/completa_fase3_pratica.component";
import { DialogCaricaVerbaleFase3Firmato } from "../../shared/carica-verbale-fase3/carica-verbale_fase3.component";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { DialogCaricaPacchettoFirmatoFase3 } from "../../shared/carica-pacchetto-firmato-fase3/carica-pacchetto_firmato_fase3.component";
import { DialogNoteReworkFase3 } from "../../shared/note-rework-fase3/note-rework_fase3.component";
import { DialogRichiediCambioCentraleBando1 } from "../../../scuola/bando1/cambio-centrale-bando1.component";
import { DialogModificaStato } from "../../shared/modifica-stato/modifica_stato.component";
import { StoricoNotePraticaComponent } from "../../shared/note-pratica/note-pratica.component";
import { Impresa } from "src/app/models/impresa.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { DialogAssegnaOdaFase1 } from "../../shared/assegna-oda/assegna-oda.component";
import { Pratica } from "src/app/models/pratica.model";
import differenceInSeconds from "date-fns/differenceInSeconds";
import { DialogCaricaPlanimetriaFase3 } from "./carica-planimetria/carica-planimetria_fase3.component";
import { DialogProgettaPraticaComponent } from "../../shared/progretta-pratica/progetta-pratica.component";
import { firstValueFrom, switchMap } from "rxjs";

declare const CSVBoxImporter: any;
@Component({
  templateUrl: "./fase3.bando2.component.html",
  styleUrls: ["./fase3.bando2.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class PraticheFase3Bando2Component implements OnInit, OnDestroy {
  protected isLoadingResults: boolean = false;
  protected mostraPraticheCompletate: boolean = false;

  private importID: string;

  protected showIniziaProgettazione: boolean = false;
  protected showGeneraDocumentazione: boolean = false;
  protected showDeliverConfirmation: boolean = false;
  protected showAnnullaConsegnaConfirmation: boolean = false;
  protected showEliminaFileALTROConfirmation: boolean = false;
  protected showEliminaFileNT9Confirmation: boolean = false;
  protected showEliminaFileFotoRouterConfirmation: boolean = false;
  protected showEliminaPlanimetriaConfirmation: boolean = false;
  protected showConfermaPreventivo: boolean = false;
  protected showResettaPratica: boolean = false;
  protected showFase1Approvata: boolean = false;
  protected showVerificaPacchettoModal: boolean = false;
  protected isVerificaPacchettoModalLoading: boolean = false;
  protected verificaPacchettoModalPratica: PraticaFlowdy2_Firestore | null =
    null;
  protected verificaPacchettoModalEsito: {
    applicabile: boolean;
    tuttiPresenti?: boolean;
    risultati: {
      path: string;
      presente: boolean;
      errore?: string;
      tipo?: "principale" | "colocata";
      cuiRiferimento?: string;
    }[];
  } | null = null;

  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public isPresidioSF: boolean = false;
  public isPresidioTIM: boolean = false;
  public isDirigenteFirmaVerbali: boolean = false;
  public isDirigenteFirmaPacchetti: boolean = false;
  public isPM: boolean = false;
  public isContabile: boolean = false;
  public isImpresa: boolean = false;
  public isDemo: boolean = false;
  protected pratiche: PraticaFlowdy2_Firestore[];
  protected praticheFiltrate: PraticaFlowdy2_Firestore[];
  protected selectedPratica: PraticaFlowdy2_Firestore;
  protected praticheSenzaEscludereLeKO: PraticaFlowdy2_Firestore[];
  protected imprese: Impresa[] = [];

  @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
  @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

  protected menuAzioniItems!: MenuItem[];
  private _filtroPratiche!: FiltroPratica;

  get filtroPratiche(): FiltroPratica {
    return this._filtroPratiche;
  }

  set filtroPratiche(value: FiltroPratica) {
    this._filtroPratiche = value;
  }

  private collection_pratiche: string =
    environment.firebase.collection_pratiche;
  private collection_importLog: string =
    environment.firebase.collection_import_log;

  private ref: DynamicDialogRef;

  protected filterTabellaIsSet: boolean = false;
  protected filterIsSet: boolean = false;
  protected filtroInLavorazione: boolean = false;
  protected filtroLotto: String;
  protected filtroStatoInfratel: String;
  protected filtroOda: String;
  protected filtroDaPagare: boolean = false;
  protected filtroLottoPerFase: String;
  protected filtroPratica: String;
  protected filtroStatoFlowdy: String;
  protected filtroImpresa: String;
  protected ragioneSocialeImpresa: String = "";
  protected paginaBack: string = null;
  protected filtroRegione: string = null;

  private csvbox_licenseKey_comunicaEsitiConsegnaFase3: string =
    environment.csvBox.secret_comunicaEsitiConsegnaFase3;
  private csvbox_importer_comunicaEsitiConsegnaFase3: any;

  private csvbox_licenseKey_comunicaInfoFase3: string =
    environment.csvBox.secret_comunicaInformazioniFase3;
  private csvbox_importer_comunicaInfoFase3: any;

  @ViewChild("praticheDT", { static: true }) praticheDT: any;

  constructor(
    private logger: NGXLogger,
    public firestore: AngularFirestore,
    public utilService: UtilService,
    protected stiliService: StiliService,
    private userService: UserService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private praticheService: PraticheService,
    private excelService: ExcelService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private odaService: OdaService,
    protected listeService: ListeService,
    //private praticheService: PraticheService,
    private scuoleService: ScuoleService,
    private googleStorageService: GoogleStorageService,
    private aziendeService: ImpreseService,
    private router: Router,
  ) {
    this._filtroPratiche = {};
    this.setUserRole();
  }

  ngOnDestroy(): void {}

  ngOnInit() {
    this.initCSVBox();
    this.logger.info("[FASE 3 BANDO 2] ON ONIT");
    const urlParamInLavorazione =
      this.activatedRoute.snapshot.paramMap.get("lavorazione");
    const urlParamLotto = this.activatedRoute.snapshot.paramMap.get("lotto");
    const urlParamCodiceInfratel =
      this.activatedRoute.snapshot.paramMap.get("stato");
    const urlParamOda = this.activatedRoute.snapshot.paramMap.get("oda");
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.paginaBack = params.get("from");
      this.filtroDaPagare = params.get("da-pagare") === "true";
      this.filtroLottoPerFase = params.get("lotto");
      this.filtroInLavorazione = params.get("in-lavorazione") === "true";
      this.filtroPratica = params.get("pratica");
      this.filtroStatoFlowdy = params.get("stato-flowdy");
      this.filtroImpresa = params.get("impresa");
      this.ragioneSocialeImpresa = params.get("ragioneSocialeImpresa");
      this.filtroRegione = params.get("regione");
    });

    if (this.filtroInLavorazione || this.filtroPratica) {
      this.filterIsSet = true;
    }
    if (this.filtroStatoFlowdy) {
      this.filterIsSet = true;
      this.filtroStatoFlowdy = this.filtroStatoFlowdy.toUpperCase();
    }
    if (this.filtroImpresa) {
      this.filterIsSet = true;
      this.filtroImpresa = this.filtroImpresa.toUpperCase();
      this.ragioneSocialeImpresa = this.ragioneSocialeImpresa.toUpperCase();
    }

    /* if(urlParamInLavorazione){
        this.filtroInLavorazione = urlParamInLavorazione;
        this.filterIsSet = true;
      } else  */ if (urlParamLotto) {
      this.filtroLotto = urlParamLotto;
      this.filterIsSet = true;
    } else if (urlParamCodiceInfratel) {
      this.filtroStatoInfratel = urlParamCodiceInfratel;
      this.filterIsSet = true;
    } else if (urlParamOda) {
      this.filtroOda = urlParamOda;
      this.filterIsSet = true;
    }
    this.loadPratiche();
    this.loadImprese();
  }
  loadImprese() {
    this.aziendeService.getByBando("2").subscribe((aziende) => {
      this.imprese = aziende;
    });
  }
  initCSVBox() {
    this.csvbox_importer_comunicaEsitiConsegnaFase3 = new CSVBoxImporter(
      this.csvbox_licenseKey_comunicaEsitiConsegnaFase3,
      {},
      (result: boolean, data: any) => {
        if (result) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail:
              data.row_success + " pratiche bando 1 AGGIORNATE con successo!",
            life: 10000,
          });
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 3 delle pratiche del bando 1",
            life: 10000,
          });
        }
      },
    );

    this.csvbox_importer_comunicaInfoFase3 = new CSVBoxImporter(
      this.csvbox_licenseKey_comunicaInfoFase3,
      {},
      (result: boolean, data: any) => {
        /* if (result) {
            this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});
    
          } else {
            this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 3 delle pratiche del bando 1', life:10000});
          } */
      },
    );

    this.csvbox_importer_comunicaEsitiConsegnaFase3.setUser({
      user_id: "default123",
    });
    this.csvbox_importer_comunicaInfoFase3.setUser({
      user_id: "default123",
    });

    this.csvbox_importer_comunicaEsitiConsegnaFase3.language = "it";
    this.csvbox_importer_comunicaInfoFase3.language = "it";
  }

  goBack() {
    this.logger.info("[PRATICHE FASE 3] GO BACK FROM: " + this.paginaBack);

    // Naviga verso la home con i parametri per selezionare il tab corretto
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
      this.router.navigate([""], {
        queryParams: {
          bando: "2", // Bando 1
          from: this.paginaBack,
        },
        queryParamsHandling: "merge",
      }),
    );
    this.removeFilter();
  }

  readImportLog() {
    const collectionRef = this.firestore.collection(
      this.collection_importLog,
    ).ref;
    let queryErrori;
    queryErrori = collectionRef.where("id", "==", this.importID);

    onSnapshot(queryErrori, (qs) => {
      this.isLoadingResults = false;
      qs.forEach((doc) => {
        let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
        if (!log.errori || log.errori.length == 0) {
          if (!log.warning || log.warning.length == 0) {
            if (log.numeroRecordNonProcessati != 0) {
              if (log.numeroRecordNonProcessati == 1) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail:
                    "Delle " +
                    log.numeroTotaleRecord +
                    " pratiche presenti nel file " +
                    log.numeroRecordProcessati +
                    " sono state processate con successo mentre " +
                    log.numeroRecordNonProcessati +
                    " non è stata processata",
                  life: 10000,
                });
              } else {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail:
                    "Delle " +
                    log.numeroTotaleRecord +
                    " pratiche presenti nel file " +
                    log.numeroRecordProcessati +
                    " sono state processate con successo mentre " +
                    log.numeroRecordNonProcessati +
                    " non sono state processate",
                  life: 10000,
                });
              }
            } else {
              this.messageService.add({
                severity: "success",
                summary: "",
                detail:
                  "Tutte le " +
                  log.numeroTotaleRecord +
                  " pratiche presenti nel file sono state processate con successo",
                life: 10000,
              });
            }
          } else {
            this.messageService.add({
              severity: "warn",
              summary: "Warning",
              detail:
                "Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con " +
                log.numeroRecordNonProcessati +
                " warning",
              life: 10000,
            });
          }
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con " +
              log.numeroRecordNonProcessati +
              " errori",
            life: 10000,
          });
        }
      });
    });
  }

  getTipoSedeAbbreviata(tipoSede: string): string {
    if (tipoSede.startsWith("M")) {
      return "Mand. " + tipoSede.charAt(tipoSede.length - 1);
    } else {
      return "Agg. " + tipoSede.charAt(tipoSede.length - 1);
    }
  }
  getPrincipaleDiUnaColocata(pratica: PraticaFlowdy2_Firestore): string {
    return pratica.colocataScuolaPrincipale;
  }
  resettaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showResettaPratica = true;
    this.selectedPratica = pratica;
  }
  confermaResetPratica() {
    this.isLoadingResults = true;
    this.praticheService.resetFase3(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "FASE 3 resettata!",
          life: 5000,
        });
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di reset della FASE 3 della pratica",
        });
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  async openCaricaAzioni(
    event: any,
    pratica: PraticaFlowdy2_Firestore,
  ): Promise<void> {
    this.selectedPratica = pratica;
    this.loadAzioni(event, pratica);
    this.azioniMenuTiered.toggle(event);
  }

  getPraticaPrincipaleDiUnaColocata(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore {
    return this.pratiche.find((pratica) => pratica.cui === cuiPrincipale);
  }

  getPraticheColocateDiUnaPrincipale(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore[] {
    return this.praticheSenzaEscludereLeKO.filter(
      (pratica) => pratica.colocataScuolaPrincipale === cuiPrincipale,
    );
  }
  getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
    cuiPrincipale: string,
    codiceInvio: string,
  ): PraticaFlowdy2_Firestore[] {
    return this.praticheSenzaEscludereLeKO.filter(
      (pratica) =>
        pratica.colocataScuolaPrincipale === cuiPrincipale &&
        pratica.codiceInvio === codiceInvio,
    );
  }

  /** Restituisce il testo per l'header della modale verifica pacchetto: CUI pratica + CUI colocate secondarie con stesso codice invio. */
  getVerificaPacchettoHeaderCui(
    pratica: PraticaFlowdy2_Firestore | null,
  ): string {
    if (!pratica?.cui) return "";
    const cuiPrincipale =
      pratica.colocataRuolo === "PRINCIPALE"
        ? pratica.cui
        : pratica.colocataScuolaPrincipale;
    const codiceInvio = pratica.codiceInvio;
    if (!cuiPrincipale || !codiceInvio) return pratica.cui;
    const secondarie =
      this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
        cuiPrincipale,
        codiceInvio,
      );
    if (secondarie.length === 0) return pratica.cui;
    const colocateCui = secondarie
      .map((s) => s.cui)
      .filter((c) => c && c !== pratica.cui);
    const colocateUnici = [...new Set(colocateCui)];
    return colocateUnici.length > 0
      ? `${pratica.cui} (${colocateUnici.join(", ")})`
      : pratica.cui;
  }

  checkCodiceInvioUgualeColocate(pratica: PraticaFlowdy2_Firestore): boolean {
    let sameCodiceInvio = true;
    if (pratica.colocataRuolo === "SECONDARIA") {
      let principale: PraticaFlowdy2_Firestore =
        this.getPraticaPrincipaleDiUnaColocata(
          pratica.colocataScuolaPrincipale,
        );
      if (principale) {
        //// this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo + " -> "+ pratica.codiceInvio + " vs "+ principale.codiceInvio);

        if (principale.codiceInvio && pratica.codiceInvio) {
          if (principale && principale.codiceInvio !== pratica.codiceInvio) {
            sameCodiceInvio = false;
          }
        } else {
          sameCodiceInvio = false;
        }
      } else {
        // this.logger.info("--> checkCodiceInvioUgualeColocate: LA PRATICA COLOCATA "+pratica.cui + " MANCA DELLA SUA PRINCIPALE");

        sameCodiceInvio = false;
      }
    } else if (pratica.colocataRuolo === "PRINCIPALE") {
      let secondarie: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      // true se almeno 2 pratiche (principale + almeno 1 secondaria) e almeno una ha stesso codiceInvio; false altrimenti
      if (secondarie.length >= 1) {
        sameCodiceInvio = secondarie.some(
          (s) => s.codiceInvio === pratica.codiceInvio,
        );
      } else {
        sameCodiceInvio = false;
      }
      /* this.logger.info(
        "pratica  ---> " +
          pratica.cui +
          " HA COLOCATA CON STESSO CODICE INVIO ? " +
          sameCodiceInvio,
      ); */
    }

    return sameCodiceInvio;
  }
  checkColocataDelivarable(pratica: PraticaFlowdy2_Firestore): boolean {
    let secondarie: PraticaFlowdy2_Firestore[] =
      this.getPraticheColocateDiUnaPrincipale(pratica.cui);
    let deliverable = false;
    secondarie.forEach((secondaria) => {
      if (
        secondaria.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
        secondaria.fotoRouterUploaded &&
        secondaria.nt9Uploaded &&
        secondaria.infoCompleted
      ) {
        if (secondaria.tipoSedeEffettiva === "D") {
          deliverable = true;
          /*  if(secondaria.planimetriaUploaded){
                deliverable = true;
              }else{
                deliverable = false;
              } */
        } else {
          deliverable = true;
        }
      }
    });

    return deliverable;
  }
  checkIfColocata2(pratica: PraticaFlowdy2_Firestore): boolean {
    //this.logger.info("checkIfColocata2 ---> "+ pratica.cui + " "+ pratica.colocata + " "+ pratica.colocataRuolo + " STESSO CODICE "+ this.checkCodiceInvioUgualeColocate(pratica));
    return (
      pratica.colocata &&
      (pratica.colocataRuolo === "PRINCIPALE" ||
        (pratica.colocataRuolo === "SECONDARIA" &&
          this.checkCodiceInvioUgualeColocate(pratica)))
    );
    //return pratica.colocata && this.checkCodiceInvioUgualeColocate(pratica);
  }

  checkIfColocataPerPacchetto(pratica: PraticaFlowdy2_Firestore): boolean {
    return pratica.colocata && this.checkCodiceInvioUgualeColocate(pratica);
  }

  /** Tipi A/C: pacchetto fase 3 senza allegato IRU né verbale firmato (come tipo C). */
  escludeDocumentiIruDaPacchetto(pratica: PraticaFlowdy2_Firestore): boolean {
    const tipoEffettiva = pratica.tipoSedeEffettiva;
    if (tipoEffettiva) {
      return (
        tipoEffettiva === "A" ||
        tipoEffettiva === "A*" ||
        tipoEffettiva === "C" ||
        tipoEffettiva === "Cy"
      );
    }
    const tipoSede = pratica.tipoSede;
    return (
      tipoSede === "A" ||
      tipoSede === "A*" ||
      tipoSede === "C" ||
      tipoSede === "Cy"
    );
  }

  checkIfColocata(pratica: PraticaFlowdy2_Firestore): boolean {
    return (
      !pratica.colocata ||
      (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
      (pratica.colocata &&
        pratica.colocataRuolo === "SECONDARIA" &&
        !this.checkCodiceInvioUgualeColocate(pratica))
    );

    //
    /* if(!pratica.colocata){
      this.logger.info("checkIfColocata ---> "+ pratica.cui + " NON COLOCATA ");

      return false;
    }else{
      if(pratica.colocataRuolo === 'PRINCIPALE'){
        return true;
      
      }else if(pratica.colocataRuolo === 'SECONDARIA'){
        if(this.checkCodiceInvioUgualeColocate(pratica)){
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA STESSO CODICE INVIO - COLOCATA");
          return true;
        }else{
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA DIVERSO CODICE INVIO - NON COLOCATA");
          return false;
        }
      }
    }
    return false; */
    /* let isNotColocata:boolean = !pratica.colocata || 
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica));
    
     return !isNotColocata; */
    /*  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)); */
  }

  checkIfColocataFordDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (!pratica.colocata) {
      this.logger.info(
        "checkIfColocataFordDeliverable ---> " + pratica.cui + " NON COLOCATA ",
      );

      return false;
    } else {
      if (this.checkCodiceInvioUgualeColocate(pratica)) {
        this.logger.info(
          "checkIfColocataFordDeliverable ---> " +
            pratica.cui +
            " COLOCATA STESSO CODICE INVIO - TORNO TRUE",
        );
        return true;
      } else {
        this.logger.info(
          "checkIfColocataFordDeliverable ---> " +
            pratica.cui +
            " COLOCATA DIVERSO CODICE INVIO - TORNO FALSE",
        );
        return false;
      }
      /* if(pratica.colocataRuolo === 'PRINCIPALE'){
          return true;
        
        }else if(pratica.colocataRuolo === 'SECONDARIA'){
          if(this.checkCodiceInvioUgualeColocate(pratica)){
            this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA STESSO CODICE INVIO - COLOCATA");
            return true;
          }else{
            this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA DIVERSO CODICE INVIO - NON COLOCATA");
            return false;
          }
        } */
    }
  }

  showDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
      pratica.infoCompleted &&
      pratica.nt9Uploaded &&
      pratica.fotoRouterUploaded
    ) {
      //&& (pratica.tipoSede==='D' && pratica.pdfPlanimetriaUploaded)
      if (pratica.tipoSedeEffettiva === "D") {
        if (pratica.planimetriaUploaded) {
          if (!pratica.colocata) {
            return true;
          } else {
            if (pratica.colocataRuolo === "PRINCIPALE") {
              return true;
            } else {
              if (this.checkCodiceInvioUgualeColocate(pratica)) {
                let secondarie: PraticaFlowdy2_Firestore[] =
                  this.getPraticheColocateDiUnaPrincipale(pratica.cui);
                secondarie.forEach((secondaria) => {
                  if (
                    !pratica.infoCompleted ||
                    !pratica.nt9Uploaded ||
                    !pratica.fotoRouterUploaded
                  ) {
                    return false;
                  }
                  return true;
                });
              } else {
                return true;
              }
            }
          }
        } else {
          return false;
        }
      } else {
        if (!pratica.colocata) {
          return true;
        } else {
          if (pratica.colocataRuolo === "PRINCIPALE") {
            return true;
          } else {
            if (this.checkCodiceInvioUgualeColocate(pratica)) {
              let secondarie: PraticaFlowdy2_Firestore[] =
                this.getPraticheColocateDiUnaPrincipale(pratica.cui);
              secondarie.forEach((secondaria) => {
                if (
                  !pratica.infoCompleted ||
                  !pratica.nt9Uploaded ||
                  !pratica.fotoRouterUploaded
                ) {
                  return false;
                }
                return true;
              });
            } else {
              return true;
            }
          }
        }
      }
    }

    return false;
  }
  showDocs(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
      pratica.infoCompleted &&
      pratica.fotoRouterUploaded
    ) {
      if (!pratica.colocata) {
        return true;
      } else {
        if (pratica.colocataRuolo === "PRINCIPALE") {
          return true;
        } else {
          if (this.checkCodiceInvioUgualeColocate(pratica)) {
            let secondarie: PraticaFlowdy2_Firestore[] =
              this.getPraticheColocateDiUnaPrincipale(pratica.cui);
            secondarie.forEach((secondaria) => {
              if (!secondaria.infoCompleted || !secondaria.fotoRouterUploaded) {
                return false;
              }
              return true;
            });
          } else {
            return true;
          }
        }
      }
    }
    return false;
  }
  loadAzioni(event: any, pratica: PraticaFlowdy2_Firestore) {
    this.menuAzioniItems = [];
    this.menuAzioniItems.push({
      label: "Storico",
      icon: PrimeIcons.HISTORY,
      style: { "font-size": "12px" },
      command: () => this.openStoricoPratica(pratica),
    });
    if (pratica.coordinateScuola && pratica.coordinateCentrale) {
      this.menuAzioniItems.push({
        label: "Posizione",
        icon: PrimeIcons.MAP_MARKER,
        style: { "font-size": "12px" },
        command: () => this.openMappaConScuola(pratica),
      });
    }

    if (this.isImpresa) {
      //IMPRESA
      if (
        pratica.statoFlowdyFase3 === "DA ASSEGNARE" ||
        (pratica.statoFlowdyFase3 === "ASSEGNATA" &&
          (!pratica.utente || pratica.utente == null))
      ) {
        this.menuAzioniItems.push({
          label: "Prendi in carico",
          icon: PrimeIcons.FILE_IMPORT,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.openPrendiInCarico(pratica),
        });
      }
      if (
        pratica.statoFlowdyFase3 !== "CONSEGNATA" &&
        pratica.statoFlowdyFase3 !== "IN ATTESA ODA" &&
        pratica.statoFlowdyFase3 !== "DA ASSEGNARE" &&
        // && pratica.statoFlowdyFase3 !== 'IN VERIFICA SMARTFIBER'
        pratica.statoFlowdyFase3 !== "IN CARICO PRESIDIO" &&
        pratica.statoFlowdyFase3 !== "IN FIRMA VERBALE" &&
        pratica.statoFlowdyFase3 !== "VERBALE FIRMATO" &&
        pratica.statoFlowdyFase3 !== "FIRMATA" &&
        pratica.statoFlowdyFase3 !== "PUBBLICATA" &&
        pratica.statoFlowdyFase3 !== "APPROVATA"
      ) {
        this.menuAzioniItems.push({
          label: "Modifica",
          icon: PrimeIcons.PENCIL,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.openModificaPraticaDialog(pratica),
          disabled: this.isDemo,
        });
      }
      if (
        pratica.statoFlowdyFase3 === "ASSEGNATA" &&
        (pratica.utente || pratica.utente != null)
      ) {
        this.menuAzioniItems.push(
          /* {
              label: "Prendi in carico",
              icon: PrimeIcons.FILE_IMPORT,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openPrendiInCarico(pratica),
            }, */
          {
            label: "Inizia progettazione",
            style: { "font-size": "11.5px", "font-weight": "bold" },
            icon: PrimeIcons.FILE_EDIT,

            command: () => this.openIniziaProgettazione(pratica),
          },
        );
        this.menuAzioniItems.push({
          label: "Cambio Centrale",
          icon: PrimeIcons.ENVELOPE,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.openRichiediModificaCentrale(pratica),
        });
      }

      if (
        pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER"
      ) {
        this.menuAzioniItems.push({
          label: "Info Fase III",
          icon: PrimeIcons.SERVER,
          style: { "font-size": "12px", "font-weight": "bold", color: "green" },
          command: () => this.openInserisciDettagli(pratica),
          //disabled: !this.simpleCheckLavorabilitaFase3(pratica)
        });
        this.menuAzioniItems.push({
          label: "Cambio Centrale",
          icon: PrimeIcons.ENVELOPE,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.openRichiediModificaCentrale(pratica),
        });

        /* this.menuAzioniItems.push({
          label: "Apri Gis2Web",
          style: { "font-size": "12px" },
          icon: PrimeIcons.MAP_MARKER,
          command: () => this.openGis2Web(pratica),
        }); */

        let itemsProgettazione: any[] = [
          {
            label: "Disegna",
            icon: PrimeIcons.PENCIL,
            style: {
              "font-size": "12px",
              "font-weight": "bold",
              color: "green",
            },
            command: () => this.openProgettaPratica(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
          /*   {
            label: "Reset",
            icon: PrimeIcons.REPLAY,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.resettaPratica(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          }, */
          {
            label: "Concludi",
            icon: PrimeIcons.CHECK,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.openConcludiProgettazion(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
          {
            label: "Scarica Pacchetto NT9",
            icon: PrimeIcons.DOWNLOAD,
            style: {
              "font-size": "11.5px",
              "font-weight": "bold",
              color: "green",
            },
            command: () => this.scaricaShapefile(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
        ];

        // Mostra "Riapri progettazione" solo quando il pacchetto NT9 è già stato generato
        if (pratica.nt9Uploaded) {
          itemsProgettazione.push({
            label: "Riapri progettazione",
            icon: PrimeIcons.UNDO,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.riapriProgettazione(pratica),
            disabled: this.isDemo,
          });
        }

        this.menuAzioniItems.push({
          label: "Progettazione",
          icon: PrimeIcons.FILE_EDIT,
          style: { "font-size": "12px", "font-weight": "bold", color: "green" },
          items: itemsProgettazione,
        });
        let itemsNT9: any[] = [];
        let itemsFotoRouter: any[] = [];
        let itemsAltro: any[] = [];
        let itemsPlanimetria: any[] = [];
        itemsNT9.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "NT9"),
        });
        itemsFotoRouter.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "FOTO ROUTER"),
        });
        itemsAltro.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "ALTRO"),
        });
        itemsPlanimetria.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.openCaricaPlanimetria(pratica),
        });
        if (pratica.nt9Uploaded) {
          itemsNT9.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "11px" },
            command: () => this.scaricaSingoloFile(pratica, "NT9"),
          });
          itemsNT9.push({
            label: "Elimina NT9",
            icon: PrimeIcons.ERASER,
            style: { "font-weight": "bold", "font-size": "11px" },
            command: () =>
              this.chiediEliminazioneTuttiFileCaricati(pratica, "NT9"),
          });
        }
        if (pratica.fotoRouterUploaded) {
          itemsFotoRouter.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "11px" },
            command: () => this.scaricaSingoloFile(pratica, "FOTO ROUTER"),
          });
          itemsFotoRouter.push({
            label: "Elimina Foto Router",
            icon: PrimeIcons.ERASER,
            style: { "font-weight": "bold", "font-size": "11px" },
            command: () =>
              this.chiediEliminazioneTuttiFileCaricati(pratica, "FOTO ROUTER"),
          });
        }
        if (pratica.fileAltriUploadedFase3) {
          itemsAltro.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaSingoloFile(pratica, "ALTRO"),
            },
            {
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(pratica, "ALTRO"),
            },
          );
        }
        if (pratica.planimetriaUploaded) {
          itemsPlanimetria.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "11px" },
            command: () => this.scaricaPlanimetria(pratica),
          });
        }

        let itemsDocumenti: any[] = [
          {
            label: "Pacchetto NT9",
            icon: PrimeIcons.BUILDING,
            style: { "font-size": "11px" },
            items: itemsNT9,
          },
          {
            label: "Foto Router",
            icon: PrimeIcons.CAMERA,
            style: { "font-size": "11px" },
            items: itemsFotoRouter,
          },
        ];
        if (pratica.tipoSedeEffettiva === "D") {
          itemsDocumenti.push({
            label: "Planimetria",
            icon: PrimeIcons.IMAGE,
            style: { "font-size": "11px" },
            items: itemsPlanimetria,
          });
        }
        itemsDocumenti.push({
          label: "Altro",
          icon: PrimeIcons.FILE,
          style: { "font-size": "11px" },
          items: itemsAltro,
        });

        this.menuAzioniItems.push({
          label: "Documentazione",
          icon: "icona-documentazione",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsDocumenti,
        });

        if (this.areDocsCreatable(pratica) && this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Genera Docs",
            icon: PrimeIcons.EYE,
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.generaDocumentazione(pratica),
          });
        }

        if (this.isDeliverable(pratica) || this.isInRework(pratica)) {
          this.menuAzioniItems.push({
            label: "Consegna",
            icon: PrimeIcons.CHECK_CIRCLE,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.consegnaPratica(pratica),
          });
        }
      }
      if (
        (pratica.statoFlowdyFase3 === "CONSEGNATA" && this.isImpresa) ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER"
      ) {
        this.menuAzioniItems.push({
          label: "Annulla Consegna",
          icon: PrimeIcons.TIMES_CIRCLE,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.annullaConsegna(pratica),
        });
      }
      if (pratica.statoFlowdyFase3 === "IN REWORK AZIENDA") {
        this.menuAzioniItems.push({
          label: "Note respingimento",
          icon: "icona-note_rework",
          style: { "font-size": "12px" },
          command: () => this.apriNoteRespingimento(pratica, false),
        });
      }
      if (pratica.statoFlowdyFase3 === "APPROVATA") {
        this.menuAzioniItems.push({
          label: "Scarica pacchetto",
          icon: "pi pi-download",
          style: { "font-size": "11px" },
          command: () => this.scaricaPacchettoPratica(pratica),
        });
      }
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDemo
    ) {
      //AZIONI SF & ADMIN
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        //items:itemsNote,
        command: () => this.visualizzaNote(pratica),
      });

      if (
        pratica.statoFlowdyFase3 === "DA ASSEGNARE" ||
        (pratica.statoFlowdyFase3 === "ASSEGNATA" &&
          (!pratica.utente || pratica.utente == null))
      ) {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Prendi in carico",
            icon: PrimeIcons.FILE_IMPORT,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.openPrendiInCarico(pratica),
          });
        }
      }

      if (
        pratica.statoFlowdyFase3 === "IN ATTESA ODA" ||
        pratica.numeroOda === null
      ) {
        //SULLA PRINCIPALE
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Assegna ODA",
            icon: "icona-assegna-oda",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.assegnaODA(pratica),
            disabled: this.isDemo,
          });
        }
      }
      this.menuAzioniItems.push({
        label: "Apri Gis2Web",
        style: { "font-size": "12px" },
        icon: PrimeIcons.MAP_MARKER,
        command: () => this.openGis2Web(pratica),
        disabled: this.isDemo,
      });
      if (
        pratica.statoFlowdyFase3 !== "IN ATTESA ODA" &&
        pratica.statoFlowdyFase3 !== "DA ASSEGNARE" &&
        pratica.statoFlowdyFase3 !== "CONSEGNATA" &&
        //&& pratica.statoFlowdyFase3 !== 'IN VERIFICA SMARTFIBER'
        pratica.statoFlowdyFase3 !== "IN CARICO PRESIDIO" &&
        pratica.statoFlowdyFase3 !== "IN FIRMA VERBALE" &&
        pratica.statoFlowdyFase3 !== "VERBALE FIRMATO" &&
        pratica.statoFlowdyFase3 !== "FIRMATA" &&
        pratica.statoFlowdyFase3 !== "PUBBLICATA" &&
        pratica.statoFlowdyFase3 !== "APPROVATA"
      ) {
        //SU TUTTE LE PRATICHE
        this.menuAzioniItems.push({
          label: "Modifica",
          icon: PrimeIcons.PENCIL,
          style: { "font-size": "12px", "font-weight": "bold" },
          command: () => this.openModificaPraticaDialog(pratica),
          disabled: this.isDemo,
        });
        /* if(this.checkIfColocata(pratica)){
              this.menuAzioniItems.push(
                {
                  label: "Cambio Centrale",
                  icon: PrimeIcons.ENVELOPE,
                  style: {  'font-size':'12px', 'font-weight': 'bold'},
                  command: () => this.openRichiediModificaCentrale(pratica),
                },
              );
            } */
      }

      if (pratica.statoFlowdyFase3 === "CONSEGNATA") {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Prendi in carico",
            icon: PrimeIcons.FILE_IMPORT,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.openPrendiInCarico(pratica),
            disabled: this.isDemo,
          });
        }
      }

      if (
        pratica.statoFlowdyFase3 === "IN ATTESA ODA" ||
        pratica.statoFlowdyFase3 === "DA ASSEGNARE" ||
        pratica.statoFlowdyFase3 === "ASSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO"
      ) {
        if (pratica.tipoSedeEffettiva && pratica.tipoSedeEffettiva === "D") {
          if (!pratica.usaVecchioModelloIRU) {
            this.menuAzioniItems.push({
              label: "Usa vecchio modello IRU",
              icon: PrimeIcons.ARROW_CIRCLE_LEFT,
              style: { "font-weight": "bold", "font-size": "10.5px" },
              command: () => this.modificaModelloIRU(pratica),
            });
          } else {
            this.menuAzioniItems.push({
              label: "Ripristina modello IRU",
              icon: PrimeIcons.REPLAY,
              style: { "font-weight": "bold", "font-size": "10.5px" },
              command: () => this.ripristinaModelloIRU(pratica),
            });
          }
        }
        if (
          pratica.tipoSedeEffettiva &&
          pratica.tipoSedeEffettiva.includes("B")
        ) {
          if (!pratica.usaVecchioModelloSUBIRU) {
            this.menuAzioniItems.push({
              label: "Vecchio modello SUBIRU",
              icon: PrimeIcons.ANGLE_DOUBLE_LEFT,
              style: { "font-weight": "bold", "font-size": "10px" },
              command: () => this.modificaModelloSUBIRU(pratica),
            });
          } else {
            this.menuAzioniItems.push({
              label: "Ripristina modello SUBIRU",
              icon: PrimeIcons.REPLAY,
              style: { "font-weight": "bold", "font-size": "10.5px" },
              command: () => this.ripristinaModelloSUBIRU(pratica),
            });
          }
        }
      }

      if (pratica.statoFlowdyFase3 === "ASSEGNATA") {
        if (this.checkIfColocata(pratica)) {
          /*  this.menuAzioniItems.push(
              {
                label: "Disegna",
                icon: PrimeIcons.FILE_EDIT,
                style: {  'font-size':'12px', 'font-weight': 'bold', 'color':'green' },
                command: () => this.openProgettaPratica(pratica),
                disabled: this.isDemo,
             
              },
            );

             */

          this.menuAzioniItems.push({
            label: "Inizia progettazione",
            style: { "font-size": "11.5px", "font-weight": "bold" },
            icon: PrimeIcons.FILE_EDIT,

            command: () => this.openIniziaProgettazione(pratica),
            disabled: this.isDemo,
          });
        } else {
          this.logger.info("ASSEGNATA ---> non è colocata");
        }
        /* this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          ); */
      }

      if (
        pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER"
      ) {
        // if(this.checkIfColocata(pratica)){
        this.menuAzioniItems.push({
          label: "Info Fase III",
          icon: PrimeIcons.SERVER,
          style: { "font-size": "12px", "font-weight": "bold", color: "green" },
          command: () => this.openInserisciDettagli(pratica),
          disabled: !this.simpleCheckLavorabilitaFase3(pratica),
          /* tooltip: "La pratica non è ancora lavorabile perchè mancano dati obbligatori" ,
                tooltipOptions: {
                  tooltipPosition: 'top',
                  tooltipStyleClass: 'p-tooltip',
                  showDelay: 500
                } */
        });
        //}

        let itemsProgettazione: any[] = [
          {
            label: "Disegna",
            icon: PrimeIcons.PENCIL,
            style: {
              "font-size": "12px",
              "font-weight": "bold",
              color: "green",
            },
            command: () => this.openProgettaPratica(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
          /*   {
            label: "Reset",
            icon: PrimeIcons.REPLAY,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.resettaPratica(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          }, */
          {
            label: "Concludi",
            icon: PrimeIcons.CHECK,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.openConcludiProgettazion(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
          {
            label: "Scarica Pacchetto NT9",
            icon: PrimeIcons.DOWNLOAD,
            style: {
              "font-size": "11.5px",
              "font-weight": "bold",
              color: "green",
            },
            command: () => this.scaricaShapefile(pratica),
            disabled: this.isDemo || pratica.nt9Uploaded,
          },
        ];

        // Mostra "Riapri progettazione" solo quando il pacchetto NT9 è già stato generato
        if (pratica.nt9Uploaded) {
          itemsProgettazione.push({
            label: "Riapri progettazione",
            icon: PrimeIcons.UNDO,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.riapriProgettazione(pratica),
            disabled: this.isDemo,
          });
        }

        this.menuAzioniItems.push({
          label: "Progettazione",
          icon: PrimeIcons.FILE_EDIT,
          style: { "font-size": "12px", "font-weight": "bold", color: "green" },
          items: itemsProgettazione,
        });

        /* this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          ); */

        let itemsNT9: any[] = [];
        let itemsFotoRouter: any[] = [];
        let itemsAltro: any[] = [];
        let itemsPlanimetria: any[] = [];
        itemsNT9.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "NT9"),
          disabled: this.isDemo,
        });
        itemsFotoRouter.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "FOTO ROUTER"),
          disabled: this.isDemo,
        });
        itemsAltro.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.caricaFile(pratica, "ALTRO"),
          disabled: this.isDemo,
        });
        itemsPlanimetria.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "11px" },
          command: () => this.openCaricaPlanimetria(pratica),
          disabled: this.isDemo,
        });
        if (pratica.nt9Uploaded) {
          itemsNT9.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "11px" },

            command: () => this.scaricaSingoloFile(pratica, "NT9"),
          });
          itemsNT9.push({
            label: "Elimina NT9",
            icon: PrimeIcons.ERASER,
            style: { "font-weight": "bold", "font-size": "11px" },
            command: () =>
              this.chiediEliminazioneTuttiFileCaricati(pratica, "NT9"),
          });
        }
        if (pratica.fotoRouterUploaded) {
          itemsFotoRouter.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaSingoloFile(pratica, "FOTO ROUTER"),
            },
            {
              label: "Elimina Foto Router",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "11px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(
                  pratica,
                  "FOTO ROUTER",
                ),
            },
          );
        }
        if (pratica.fileAltriUploadedFase3) {
          itemsAltro.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaSingoloFile(pratica, "ALTRO"),
            },
            {
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(pratica, "ALTRO"),
            },
          );
        }
        if (pratica.planimetriaUploaded) {
          itemsPlanimetria.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaPlanimetria(pratica),
            },
            {
              label: "Elimina",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(
                  pratica,
                  "PLANIMETRIA",
                ),
            },
          );
        }
        let itemsDocumenti: any[] = [
          {
            label: "Pacchetto NT9",
            icon: PrimeIcons.BUILDING,
            style: { "font-size": "11px" },
            items: itemsNT9,
          },
          {
            label: "Foto Router",
            icon: PrimeIcons.CAMERA,
            style: { "font-size": "11px" },
            items: itemsFotoRouter,
          },
        ];
        if (pratica.tipoSedeEffettiva === "D") {
          itemsDocumenti.push({
            label: "Foto Planimetria",
            icon: PrimeIcons.IMAGE,
            items: itemsPlanimetria,
          });
        }
        itemsDocumenti.push({
          label: "Altro",
          icon: PrimeIcons.FILE,
          style: { "font-size": "11px" },
          items: itemsAltro,
        });
        this.menuAzioniItems.push({
          label: "Documentazione",
          icon: "icona-documentazione",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsDocumenti,
        });

        if (this.areDocsCreatable(pratica) && this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Genera Docs",
            icon: PrimeIcons.EYE,
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.generaDocumentazione(pratica),
            disabled: this.isDemo,
          });
        }

        if (this.isDeliverable(pratica) || this.isInRework(pratica)) {
          this.menuAzioniItems.push({
            label: "Consegna",
            icon: PrimeIcons.CHECK_CIRCLE,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.consegnaPratica(pratica),
            disabled: this.isDemo,
          });
        }
      }
      if (pratica.statoFlowdyFase3 === "IN REWORK AZIENDA") {
        this.menuAzioniItems.push({
          label: "Note respingimento",
          icon: "icona-note_rework",
          style: { "font-size": "12px" },
          command: () => this.apriNoteRespingimento(pratica, false),
        });
      }

      if (
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER"
      ) {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push(
            {
              label: "Rigenera Docs",
              icon: PrimeIcons.REPLAY,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.rigeneraDocs(pratica),
            },
            {
              label: "Scarica File",
              icon: PrimeIcons.CLOUD_DOWNLOAD,
              style: { "font-size": "12px" },
              items: [
                {
                  label: "NT9",
                  icon: PrimeIcons.MAP,
                  styleClass: "RETstyle",
                  style: { "font-size": "12px" },
                  command: () => this.scaricaNT9(pratica),
                },
                {
                  label: "RET",
                  icon: PrimeIcons.FILE_WORD,
                  styleClass: "RETstyle",
                  style: { "font-size": "12px" },
                  command: () => this.scaricaDocs("RET", pratica),
                },
                {
                  label: "PSI",
                  icon: PrimeIcons.FILE_WORD,
                  styleClass: "RETstyle",
                  style: { "font-size": "12px" },
                  command: () => this.scaricaDocs("PSI", pratica),
                },
                ...(!this.escludeDocumentiIruDaPacchetto(pratica)
                  ? [
                      {
                        label: "ALL.IRU",
                        icon: PrimeIcons.FILE_WORD,
                        styleClass: "RETstyle",
                        style: { "font-size": "12px" },
                        command: () => this.scaricaDocs("IRU", pratica),
                      },
                    ]
                  : []),
                {
                  label: "TUTTI",
                  icon: PrimeIcons.REPLAY,
                  styleClass: "RETstyle",
                  style: { "font-size": "12px" },
                  command: () => this.scaricaDocs("ALL", pratica),
                },
              ],
              // command: () => this.openScaricaDocumentazionePratica(pratica),
            },
          );
        }
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Annulla Consegna",
            icon: PrimeIcons.TIMES_CIRCLE,
            style: { "font-size": "12px", "font-weight": "bold" },
            command: () => this.annullaConsegna(pratica),
            disabled: this.isDemo,
          });
        }
      }
      if (pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER") {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Valida consegna",
            icon: "icona-validazione-consegna",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.validaConsegna(pratica),
            disabled: this.isDemo,
          });
        }
      }

      if (
        pratica.statoFlowdyFase3 !== "IN FIRMA VERBALE" &&
        // && pratica.statoFlowdyFase3!=='IN CARICO PRESIDIO'
        pratica.statoFlowdyFase3 !== "VERBALE FIRMATO" &&
        pratica.statoFlowdyFase3 !== "FIRMATA"
        // && pratica.statoFlowdyFase3!=='PUBBLICATA'
        // && pratica.statoFlowdyFase3!=='APPROVATA'
      ) {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Resetta",
            icon: "icona-reset",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.resettaPratica(pratica),
            disabled: this.isDemo,
          });
        }
      }
      //01/09/2025: cambia stato in tutte le fasi possibili
      if (this.checkIfColocata(pratica)) {
        this.menuAzioniItems.push({
          label: "Cambia Stato",
          icon: PrimeIcons.DIRECTIONS,
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.forzaStatoPratica(pratica),
          disabled: this.isDemo,
        });
      }

      // pratica.statoFlowdyFase3==='IN CARICO PRESIDIO' ||
      if (
        pratica.statoFlowdyFase3 === "VERBALE FIRMATO" ||
        pratica.statoFlowdyFase3 === "FIRMATA" ||
        pratica.statoFlowdyFase3 === "PUBBLICATA" ||
        pratica.statoFlowdyFase3 === "APPROVATA" ||
        pratica.statoFlowdyFase3 === "RESPINTA" ||
        pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO"
      ) {
        this.menuAzioniItems.push({
          label: "Scarica pacchetto",
          icon: "icona-scarica_pacchetto",
          style: { "font-size": "12px" },
          command: () => this.scaricaPacchettoPratica(pratica),
        });
      }

      if (
        (pratica.statoFlowdyFase3 === "VERBALE FIRMATO" ||
          pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") &&
        this.checkIfColocata(pratica)
      ) {
        this.menuAzioniItems.push({
          label: "Verifica file pacchetto",
          icon: "pi pi-search",
          style: { "font-size": "12px" },
          command: () => this.openVerificaFilePacchettoModal(pratica),
        });
      }
      if (
        this.checkIfColocata(pratica) &&
        (pratica.statoFlowdyFase3 === "IN FIRMA VERBALE" ||
          pratica.statoFlowdyFase3 === "VERBALE FIRMATO" ||
          pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO")
      ) {
        this.menuAzioniItems.push({
          label: "Rigenera docs",
          icon: "pi pi-sync",
          style: { "font-size": "12px" },
          command: () => this.rigeneraDocsPraticaCompleta(pratica),
        });
      }

      if (pratica.statoFlowdyFase3 === "RESPINTA") {
        this.menuAzioniItems.push(
          /*   {
              label: "Scarica pacchetto",
               icon: 'icona-scarica_pacchetto',
               style: {   'font-size': '12px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            }, */
          {
            label: "Note respingimento",
            icon: "icona-note_rework",
            style: { "font-size": "12px" },
            command: () => this.apriNoteRespingimento(pratica, true),
          },
          {
            label: "Prendi in carico",
            icon: "icona-sf_in_carico",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.openPrendiInCarico(pratica),
            disabled: this.isDemo,
          },
        );
      }
    } else if (this.isPresidioTIM) {
      //AZIONI PRESIDIO TIM
      if (
        pratica.statoFlowdyFase3 !== "PUBBLICATA" &&
        pratica.statoFlowdyFase3 !== "APPROVATA" &&
        pratica.statoFlowdyFase3 !== "RIFIUTATA"
      ) {
        this.menuAzioniItems.push({
          label: "Codice Invio",
          style: { "font-size": "12px", "font-weight": "bold" },
          icon: PrimeIcons.PENCIL,
          command: () => this.openCambiaCodiceInvio(pratica),
        });
      }
      if (pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push(
            {
              label: "Completa Pratica",
              style: { "font-size": "12px", "font-weight": "bold" },
              icon: PrimeIcons.FILE_EDIT,
              command: () => this.openCompletaPraticaPresidioTIM(pratica),
            },
            {
              label: "Rifiuta consegna",
              icon: "icona-rifiuta_consegna",
              style: { "font-weight": "bold", "font-size": "11px" },
              command: () => this.rifiutaConsegna(pratica),
            },
          );
        }
      }

      if (pratica.statoFlowdyFase3 === "IN FIRMA VERBALE") {
        let itemsVerbale: any[] = [];
        itemsVerbale.push(
          {
            label: "Scarica da firmare",
            icon: PrimeIcons.DOWNLOAD,
            style: { "font-size": "11px" },
            command: () => this.scaricaVerbale(pratica, false),
          },
          {
            label: "Carica Firmato",
            icon: "pi pi-upload",
            style: { "font-size": "11px" },
            command: () => this.caricaVerbaleFirmato(pratica, false),
          },
        );

        this.menuAzioniItems.push({
          label: "Verbale",
          icon: "icona-verbale-fase3",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsVerbale,
        });
      }

      if (pratica.statoFlowdyFase3 === "VERBALE FIRMATO") {
        if (this.checkIfColocata(pratica)) {
          let itemsVerbale: any[] = [];

          itemsVerbale.push(
            {
              label: pratica.tipoSedeEffettiva.endsWith("D")
                ? "Carica nuovi"
                : "Carica nuovo",
              icon: "pi pi-upload",
              style: { "font-size": "11px" },
              command: () => this.caricaVerbaleFirmato(pratica, true),
            },
            {
              label: pratica.tipoSedeEffettiva.endsWith("D")
                ? "Scarica firmati"
                : "Scarica firmato",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaVerbaleFirmato(pratica),
              // disabled: pratica.tipoSedeEffettiva.endsWith('D') && !pratica.ha2Tratte
            },
          );

          let itemsPacchetto: any[] = [];
          itemsPacchetto.push(
            {
              label: "Scarica da firmare",
              icon: "pi pi-download",
              style: { "font-size": "11px" },
              command: () => this.scaricaPacchettoPratica(pratica),
            },
            {
              label: "Carica firmato",
              icon: "pi pi-upload",
              style: { "font-size": "11px" },
              command: () => this.caricaPacchettoFirmato(pratica),
            },
          );

          this.menuAzioniItems.push(
            {
              label: "Verbale",
              icon: "icona-verbale-fase3",
              style: { "font-weight": "bold", "font-size": "12px" },
              items: itemsVerbale,
            },
            {
              label: "Pacchetto",
              icon: "icona-scarica_pacchetto",
              style: { "font-weight": "bold", "font-size": "12px" },
              items: itemsPacchetto,
            },
          );
        } else {
          //TODO: GESTIONE COLOCATE
          //this.openScaricaPacchettoPraticaColocata(pratica, isBulk);
        }
      }
      if (pratica.statoFlowdyFase3 === "FIRMATA") {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push(
            {
              label: "Scarica Pacchetto",
              icon: "icona-scarica_pacchetto",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.scaricaPacchettoFirmatoPratica(pratica),
            },
            {
              label: "Invio Infratel",
              icon: "icona-invio-infratel",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.comunicaInvioInfratelPratica(pratica),
            },
          );
        }
      }
      if (pratica.statoFlowdyFase3 === "PUBBLICATA") {
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Esito",
            icon: "icona-comunica_esito",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: [
              {
                label: "Approvata",
                icon: "icona-approvata",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoFase3(pratica, true),
              },
              {
                label: "Respinta",
                icon: "icona-respinta",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoFase3(pratica, false),
              },
            ],
          });
        }
      }
      if (
        pratica.statoFlowdyFase3 === "PUBBLICATA" ||
        pratica.statoFlowdyFase3 === "APPROVATA" ||
        pratica.statoFlowdyFase3 === "RIFIUTATA"
      ) {
        //TODO: DA TOGLIERE
        if (this.checkIfColocata(pratica)) {
          this.menuAzioniItems.push({
            label: "Scarica Pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.scaricaPacchettoFirmatoPratica(pratica),
          });
        }
      }
    } else if (this.isDirigenteFirmaPacchetti) {
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        command: () => this.visualizzaNote(pratica),
      });
    }
  }

  openRichiediModificaCentrale(pratica: PraticaFlowdy2_Firestore): void {
    this.logger.info(
      "--->  RICHIEDI CAMBIO CENTRALE DELLA PRATICA " + pratica.cui,
    );

    this.ref = this.dialogService.open(DialogRichiediCambioCentraleBando1, {
      data: {
        pratica: pratica,
      },
      header: "Richiesta cambio centrale ",
      width: "85%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((changeRequested) => {
      if (changeRequested && changeRequested.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail: "Richiesta inviata con successo",
        });
      }
    });
  }

  async scaricaPacchettoFirmatoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info(
      "---> SCARICO IL PACCHETTO FIRMATO DELLA PRATICA " + pratica.cui,
    );
    this.isLoadingResults = true;
    const storage = getStorage();
    const pathReferenceSignedNT9Zip = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/SIGNED/" +
        pratica.codiceInvio +
        ".zip.p7m",
    );
    const pathReferenceSignedPraticaZip = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/SIGNED/" +
        pratica.cui +
        ".zip.p7m",
    );
    const pathPacchettoFirmatoFase3 = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/" +
        pratica.codiceInvio +
        ".zip.p7m",
    );
    const pathPacchettoFirmatoLegacy = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/SIGNED/" +
        pratica.codiceInvio +
        ".zip.p7m",
    );
    let filesToDownload = [
      //pathReferenceSignedNT9Zip,
      //pathReferenceSignedPraticaZip
      pathPacchettoFirmatoFase3,
      pathPacchettoFirmatoLegacy,
    ];

    let fileScaricato = false;
    for (const pathRef of filesToDownload) {
      try {
        const blob = await getBlob(pathRef);
        if (blob) {
          this.logger.info(pathRef.name);
          saveAs(blob, pathRef.name);
          fileScaricato = true;
          this.isLoadingResults = false;
          break;
        } else {
          this.logger.info(`Errore durante il download di ${pathRef.name}`);
        }
      } catch (error) {
        if (
          error.code === "storage/object-not-found" &&
          pathRef === pathPacchettoFirmatoFase3
        ) {
          // Provo il path legacy solo se il file non e' presente nel nuovo path FASE3.
          continue;
        }
        this.isLoadingResults = false;
        if (error.code === "storage/object-not-found") {
          this.logger.info("Il file non esiste:", error.message);
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            life: 10000,
            detail: "Il file " + error.message + " non esiste",
          });
        } else {
          // Gestisci altri tipi di errori
          this.logger.info("Errore sconosciuto:", error);
        }
      }
    }
    if (!fileScaricato) {
      this.isLoadingResults = false;
    }
    /* this.confirmationService.confirm({
          message: `Confermi di voler procedere con lo scaricamento del pacchetto della pratica ${pratica.cui}? L'operazione indicherà che la pratica è stata inoltrata al cliente!`,
          header: "Scarica pacchetto firmato",
          icon: "pi pi-file-import",
          acceptLabel: "CONFERMA",
          acceptButtonStyleClass: "p-button-success",
          rejectLabel: "ANNULLA",
          rejectButtonStyleClass: "p-button-warning",
          accept: async () => {
            
            },
            reject: () => {
              //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
            },
          }); */
  }

  caricaPacchettoFirmato(pratica: PraticaFlowdy2_Firestore): void {
    this.ref = this.dialogService.open(DialogCaricaPacchettoFirmatoFase3, {
      data: {
        pratica: pratica,
      },
      header: "Carica Pacchetto Firmato della pratica " + pratica.cui,
      width: "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        this.isLoadingResults = true;
        //if(!isRicarica){
        this.praticheService
          .confermaCaricamentoPacchetto(pratica.id)
          .subscribe((res) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "",
              life: 10000,
              detail: "Pacchetto firmato caricato con successo",
            });
          });
        //}
      }
    });
  }

  async scaricaVerbaleFirmato(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info(
      "---> SCARICO VERBALE FIRMATO DELLA PRATICA " + pratica.cui,
    );
    const storage = getStorage();
    const pathReferenceFileVerbale = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
        pratica.cui +
        ".pdf.p7m",
    );
    // const pathReferenceFileVerbale                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/Contratto_Cessione_IRU_"+pratica.cui+".pdf");

    try {
      const blob = await getBlob(pathReferenceFileVerbale);
      saveAs(blob, "Contratto_Cessione_IRU_" + pratica.cui + ".pdf.p7m");
      if (pratica.tipoSedeEffettiva === "D" && pratica.ha2Tratte) {
        const pathReferenceFileVerbaleTratta2 = ref(
          storage,
          "pratiche/scuola/" +
            pratica.cui +
            "/OUT/FASE3/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
            pratica.cui +
            ".pdf.p7m",
        );
        const blobTratta2 = await getBlob(pathReferenceFileVerbaleTratta2);
        saveAs(
          blobTratta2,
          "Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
            pratica.cui +
            ".pdf.p7m",
        );
      }
    } catch (error) {
      if (error.code === "storage/object-not-found") {
        this.logger.info("Il file non esiste:", error.message);
        this.messageService.add({
          severity: "info",
          summary: "Errore",
          life: 10000,
          detail: "Verbale firmato NON esistente",
        });
      } else {
        // Gestisci altri tipi di errori
        this.logger.info("Errore sconosciuto:", error);
      }
    }
  }

  async caricaVerbaleFirmato(
    pratica: PraticaFlowdy2_Firestore,
    isRicarica: boolean,
  ): Promise<void> {
    let headerVerbale = "";
    let richiedeDueVerbali = false;
    if (pratica.tipoSedeEffettiva.endsWith("D")) {
      if (
        this.checkIfColocataPerPacchetto(pratica) &&
        pratica.colocata &&
        pratica.colocataRuolo === "SECONDARIA"
      ) {
        this.logger.info(
          "checkIfColocataPerPacchetto: " +
            this.checkIfColocataPerPacchetto(pratica),
        );
        this.logger.info("pratica.colocata: " + pratica.colocata);
        this.logger.info("pratica.colocataRuolo: " + pratica.colocataRuolo);
        try {
          const praticaCompleta = await firstValueFrom(
            this.praticheService.getById(pratica.id.toString()),
          );
          const scuola = await firstValueFrom(
            this.scuoleService.getById(praticaCompleta.scuola.id.toString()),
          );
          this.logger.info(
            "scuola.cpeInStessoLocale: " + scuola.cpeInStessoLocale,
          );
          if (scuola.cpeInStessoLocale) {
            headerVerbale =
              "Carica Verbale Firmato della Pratica " + pratica.cui;
            richiedeDueVerbali = false;
          } else {
            headerVerbale =
              "Carica Verbali Firmati della Pratica " + pratica.cui;
            richiedeDueVerbali = true;
          }
        } catch (err) {
          this.logger.error(
            "[FASE 3 BANDO 2] Errore getById pratica/scuola principale prima scaricaVerbaleProprieta",
            err,
          );
          // In caso di errore, mantengo il comportamento standard di tipo D (due verbali)
          headerVerbale = "Carica Verbali Firmati della Pratica " + pratica.cui;
          richiedeDueVerbali = true;
        }
      } else {
        headerVerbale = "Carica Verbali Firmati della Pratica " + pratica.cui;
        richiedeDueVerbali = true;
      }
    } else {
      headerVerbale = "Carica Verbale Firmato della Pratica " + pratica.cui;
      richiedeDueVerbali = false;
    }
    this.ref = this.dialogService.open(DialogCaricaVerbaleFase3Firmato, {
      data: {
        pratica: pratica,
        richiedeDueVerbali: richiedeDueVerbali,
      },
      header: headerVerbale,
      width: "50%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        this.isLoadingResults = true;
        //if(!isRicarica){
        this.praticheService
          .confermaCaricamentoVerbale(pratica.id)
          .subscribe((res) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "",
              life: 10000,
              detail: "Verbale FIRMATO caricato con successo",
            });
          });
        //}
      }
    });
  }

  async scaricaVerbale(pratica: PraticaFlowdy2_Firestore, isBulk: boolean) {
    this.logger.info(
      "[FASE 3 BANDO 2] PRATICA " + pratica.cui + " SCARICO VERBALE DA FIRMARE",
    );
    if (!isBulk) {
      //this.logger.info("---> non bulk ");

      this.confirmationService.confirm({
        message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
        header: "ATTENZIONE!",
        icon: "pi pi-exclamation-circle",
        acceptLabel: "PROCEDI",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: async () => {
          const storage = getStorage();
          const pathReferenceFileVerbale = ref(
            storage,
            "pratiche/scuola/" +
              pratica.cui +
              "/OUT/FASE3/Contratto_Cessione_IRU_" +
              pratica.cui +
              ".pdf",
          );
          try {
            const blob = await getBlob(pathReferenceFileVerbale);
            saveAs(blob, "Contratto_Cessione_IRU_" + pratica.cui + ".pdf");
            if (pratica.tipoSedeEffettiva === "D") {
              let scaricaVerbaleProprieta = true;
              /* this.logger.info(
                "[FASE 3 BANDO 2] TIPO D --> ha2Tratte: " + pratica.ha2Tratte,
              ); */
              /*  
                && pratica.ha2Tratte */

              /*    this.logger.info(
                "[FASE 3 BANDO 2] checkIfColocataPerPacchetto: " +
                  this.checkIfColocataPerPacchetto(pratica),
              );
              this.logger.info(
                "[FASE 3 BANDO 2] checkIfColocata: " +
                  this.checkIfColocata(pratica),
              );
              this.logger.info(
                "[FASE 3 BANDO 2] checkIfColocata2: " +
                  this.checkIfColocata2(pratica),
              );
 */
              if (this.checkIfColocata(pratica)) {
                /* try {
                  const praticaCompleta = await firstValueFrom(
                    this.praticheService.getById(pratica.id.toString()),
                  );
                  const scuola = await firstValueFrom(
                    this.scuoleService.getById(
                      praticaCompleta.scuola.id.toString(),
                    ),
                  );
                  if (scuola.cpeInStessoLocale) {
                    scaricaVerbaleProprieta = false;
                  }
                  this.logger.info(
                    "[FASE 3 BANDO 2] PRINCIPALE DI TIPO D con cpeInStessoLocale: " +
                      scaricaVerbaleProprieta,
                  );
                } catch (err) {
                  this.logger.error(
                    "[FASE 3 BANDO 2] Errore getById pratica/scuola principale prima scaricaVerbaleProprieta",
                    err,
                  );
                } */
                this.logger.info(
                  "[FASE 3 BANDO 2] PRATICA " +
                    pratica.cui +
                    " PRINCIPALE DI TIPO D - SCARICO SEMPRE VERBALE PROPRIETA ",
                );
              } else {
                try {
                  const praticaCompleta = await firstValueFrom(
                    this.praticheService.getById(pratica.id.toString()),
                  );
                  const scuola = await firstValueFrom(
                    this.scuoleService.getById(
                      praticaCompleta.scuola.id.toString(),
                    ),
                  );
                  if (scuola.cpeInStessoLocale) {
                    scaricaVerbaleProprieta = false;
                  }
                } catch (err) {
                  this.logger.error(
                    "[FASE 3 BANDO 2] Errore getById pratica/scuola principale prima scaricaVerbaleProprieta",
                    err,
                  );
                }
                this.logger.info(
                  "[FASE 3 BANDO 2] PRATICA " +
                    pratica.cui +
                    " SECONDARIA O FALSA COLOCATA DI TIPO D con scaricaVerbaleProprieta: " +
                    scaricaVerbaleProprieta,
                );
              }

              if (scaricaVerbaleProprieta) {
                const pathReferenceFileVerbaleTratta2 = ref(
                  storage,
                  "pratiche/scuola/" +
                    pratica.cui +
                    "/OUT/FASE3/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
                    pratica.cui +
                    ".pdf",
                );
                const blobTratta2 = await getBlob(
                  pathReferenceFileVerbaleTratta2,
                );
                saveAs(
                  blobTratta2,
                  "Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
                    pratica.cui +
                    ".pdf",
                );
              }
            } else {
              this.logger.info(
                "[FASE 3 BANDO 2] PRATICA " +
                  pratica.cui +
                  " NON DI TIPO D - SCARICO SOLO VERBALE CESSIONE IRU ",
              );
            }
            //saveAs(blob, "Verbale_Cessione_IRU_"+pratica.codiceInvio+".pdf");
          } catch (error) {
            if (error.code === "storage/object-not-found") {
              this.logger.info("Il file non esiste:", error.message);
              this.messageService.add({
                severity: "info",
                summary: "Errore",
                life: 10000,
                detail: "Verbale cessione IRU NON esistente",
              });
            } else {
              this.logger.info("Errore sconosciuto:", error);
            }
          }
        },
        reject: () => {},
      });
    } else {
      const storage = getStorage();
      const pathReferenceFileVerbale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/Verbale_Cessione_IRU_" +
          pratica.codiceInvio +
          ".pdf",
      );

      try {
        const blob = await getBlob(pathReferenceFileVerbale);
        saveAs(blob, "Verbale_Cessione_IRU_" + pratica.codiceInvio + ".pdf");
      } catch (error) {
        if (error.code === "storage/object-not-found") {
          this.logger.info("Il file non esiste:", error.message);
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            life: 10000,
            detail: "Verbale cessione IRU NON esistente",
          });
        } else {
          this.logger.info("Errore sconosciuto:", error);
        }
      }
    }
  }

  openCompletaPraticaPresidioTIM(pratica: PraticaFlowdy2_Firestore): void {
    this.logger.info("---> presidio completa la pratica");
    this.praticheService
      .getById(pratica.id.toString())
      .subscribe((praticaDaDB) => {
        this.ref = this.dialogService.open(CompletaFase3Bando2, {
          data: {
            pratica: praticaDaDB,
            praticaFromFirestore: pratica,
          },
          header: "Completamento Pratica " + pratica.cui,
          width: "60%",
          height: "60%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((infoUpdated) => {
          if (infoUpdated && infoUpdated.success) {
            this.messageService.add({
              severity: "success",
              summary: "",
              life: 10000,
              detail: "Praticha completata con successo",
            });
          }
        });
      });
  }

  openCambiaCodiceInvio(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(ModificaCodiceinvio, {
      data: {
        pratica: pratica,
      },
      header: "Modifica CODICE INVIO della Pratica " + pratica.cui,
      width: "65%",
      height: "45%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((infoUpdated) => {
      if (infoUpdated && infoUpdated.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail: "CODICE INVIO modificato con successo",
        });
      }
    });
  }

  isDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
      pratica.fotoRouterUploaded &&
      pratica.nt9Uploaded &&
      pratica.infoCompleted
    ) {
      if (pratica.tipoSedeEffettiva === "D") {
        if (!pratica.colocata) {
          //this.logger.info("isDeliverable ---> pratica D + non colocata");
          if (pratica.planimetriaUploaded) {
            this.logger.info(
              "isDeliverable ---> pratica D + non colocata e planimetria OK",
            );
            return true;
          } else {
            this.logger.info(
              "isDeliverable ---> pratica D + non colocata e planimetria KO",
            );
            return false;
          }
          //return true;
        } else {
          if (this.checkIfColocataFordDeliverable(pratica)) {
            if (pratica.planimetriaUploaded) {
              this.logger.info(
                "isDeliverable ---> pratica D + con planimetria OK -> CONTROLLO LE COLOCATE",
              );

              return this.checkColocataDelivarable(pratica);
            } else {
              this.logger.info(
                "isDeliverable ---> pratica D + con planimetria KO ",
              );

              return false;
            }
          } else {
            this.logger.info("isDeliverable ---> pratica D + non colocata");

            return true;
          }

          /* if(this.checkIfColocataFordDeliverable(pratica)){
              this.logger.info("isDeliverable ---> pratica D + colocata");

              return this.checkColocataDelivarable(pratica);
            }else{
              this.logger.info("isDeliverable ---> pratica D + non colocata");

              return true;
            } */
        }
      } else {
        if (this.checkIfColocataFordDeliverable(pratica)) {
          this.logger.info("isDeliverable ---> pratica non D + colocata");

          return this.checkColocataDelivarable(pratica);
        } else {
          this.logger.info("isDeliverable ---> pratica non D + non colocata");

          return true;
        }
        /*  if(!pratica.colocata){
            this.logger.info("isDeliverable ---> pratica non D e non è colocata");
            return true;
          }else{
            if(this.checkIfColocata(pratica)){
              this.logger.info("isDeliverable ---> pratica non D colocata");
             
              return this.checkColocataDelivarable(pratica);
            }else{
              this.logger.info("isDeliverable ---> non è colocata");
              return true;
            }
            //return this.checkColocataDelivarable(pratica);
          } */
        /*  */
      }
    }
    return false;
  }

  isInRework(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.statoFlowdyFase3 === "IN REWORK AZIENDA") {
      return true;
    }
    return false;
  }

  generaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
    this.showGeneraDocumentazione = true;
    this.selectedPratica = pratica;
  }

  confermaGenerazioneDocumentazione() {
    this.isLoadingResults = true;
    this.praticheService.generaDocsFase3(this.selectedPratica.id).subscribe({
      next: (v) => {},
      error: (e) => {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "info",
          summary: "Errore",
          life: 10000,
          detail: "Errore in fase di generazione dei docs della pratica",
        });
      },
      complete: () => {
        this.messageService.add({
          severity: "success",
          summary: "Generazione documentazione",
          life: 2000,
          detail: "Documentazione generata con successo, attendere il download",
        });
        this.scaricaPreviewDocsPratica(this.selectedPratica);
        this.isLoadingResults = false;
        this.showGeneraDocumentazione = false;
        this.selectedPratica = null;
      },
    });
  }

  async scaricaPreviewDocsPratica(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info(
      "---> SCARICO LA PREVIEW DEI DOCS DELLA PRATICA " + pratica.cui,
    );
    this.isLoadingResults = true;
    const storage = getStorage();
    const zip = new JSZip();
    const pathReferenceRET = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_RET_01_0.docx",
    );
    const pathReferencePSI = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_PSI_02_0.docx",
    );
    const pathReferenceAllegatoIRU = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
        pratica.cui +
        ".docx",
    );
    let filesToDownload = [
      pathReferenceRET,
      pathReferencePSI,
      //   pathReferenceAllegatoIRU,
    ];
    if (!this.escludeDocumentiIruDaPacchetto(pratica)) {
      filesToDownload.push(pathReferenceAllegatoIRU);
      if (this.checkIfColocata(pratica)) {
        let colocate: PraticaFlowdy2_Firestore[] =
          this.getPraticheColocateDiUnaPrincipale(pratica.cui);
        colocate.forEach((praticaColocata) => {
          if (praticaColocata.codiceInvio === pratica.codiceInvio) {
            const pathReferenceAllegatoIRUColocata = ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
                praticaColocata.cui +
                ".docx",
            );

            filesToDownload.push(pathReferenceAllegatoIRUColocata);
          }
        });
      }
    }

    const downloadPromises = [];
    for (const pathRef of filesToDownload) {
      const blob = await getBlob(pathRef);
      if (blob) {
        this.logger.info(pathRef.name);
        zip.file(pathRef.name, blob);

        downloadPromises.push(Promise.resolve());
      } else {
        console.error(`Errore durante il download di ${pathRef.name}`);
        //this.isLoadingResults = false;
      }
    }
    Promise.all(downloadPromises)
      .then(() => {
        // Crea il file zip e avvia il download:
        let fileName: string = pratica.cui;
        if (this.checkIfColocata(pratica)) {
          let colocate: PraticaFlowdy2_Firestore[] =
            this.getPraticheColocateDiUnaPrincipale(pratica.cui);
          if (colocate.length > 0) {
            fileName = pratica.cui;
            colocate.forEach((praticaColocata) => {
              if (praticaColocata.codiceInvio === pratica.codiceInvio) {
                //this.logger.info("fileName ---> "+ praticaColocata.cui);
                fileName += "_" + praticaColocata.cui;
              }
            });
          }
        }
        fileName += ".zip";
        zip
          .generateAsync({ type: "blob" })
          .then((blob) => {
            saveAs(blob, fileName); // Scarica il file zip
            this.isLoadingResults = false;
          })
          .catch((error) => {
            console.error("Errore durante la creazione dello zip:", error);
            this.isLoadingResults = false;
          });
      })
      .catch((error) => {
        console.error("Errore durante il download dei file:", error);
        this.isLoadingResults = false;
      });
    //this.isLoadingResults = false;
  }

  areDocsCreatable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
      pratica.fotoRouterUploaded &&
      pratica.infoCompleted
    ) {
      return true;
    }
    return false;
  }

  openCaricaPlanimetria(pratica: PraticaFlowdy2_Firestore): void {
    this.ref = this.dialogService.open(DialogCaricaPlanimetriaFase3, {
      data: {
        pratica: pratica,
      },
      header: "Carica Planimetria per pratica " + pratica.cui,
      width: "70%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((uploadResult) => {
      if (uploadResult.success) {
        const collectionRef = this.firestore.collection(
          this.collection_pratiche,
        );
        const documentRef = collectionRef.doc(pratica.cui.valueOf());
        const updatedData = { planimetriaUploaded: true };
        documentRef
          .update(updatedData)
          .then(() => {
            this.logger.log(
              "Campo planimetriaUploaded aggiornato con successo",
            );
          })
          .catch((error) => {
            this.logger.error(
              "ERRORE AGGIORNATO CAMPO planimetriaUploaded SU FIRESTORE",
            );
          });
        this.praticheService
          .confermaCaricamentoPlanimetria(
            pratica.id,
            uploadResult.fileExtension,
          )
          .subscribe((res) => {
            this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO PLANIMETRIA");
          });
        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail: "Planimetria caricata con successo",
        });
      }
    });
  }

  showPlanimetriaUploaded(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      (pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA") &&
      pratica.planimetriaUploaded
    ) {
      //&& (!pratica.infoCompleted && !pratica.fotoRouterUploaded)
      return true;
    }
    return false;
  }

  async scaricaPlanimetria(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3`;
    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);

      // Filtra i file che iniziano con "PLANIMETRIA"
      const planimetriaFiles = fileList.items.filter((item) =>
        item.name.toUpperCase().startsWith("PLANIMETRIA"),
      );

      if (planimetriaFiles.length === 0) {
        throw new Error("Nessuna planimetria trovata");
      }

      // Scarica il primo file trovato (dovrebbe essercene solo uno)
      const fileRef = planimetriaFiles[0];
      const filePath = `${folderPath}/${fileRef.name}`;
      const fileReference = ref(storage, filePath);
      const blobFile = await getBlob(fileReference);
      saveAs(blobFile, fileRef.name);

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Nessuna planimetria trovata per questa pratica",
        life: 10000,
      });
    }
  }

  async scaricaSingoloFile(
    pratica: PraticaFlowdy2_Firestore,
    tipoDocumento: string,
  ) {
    if (tipoDocumento === "NT9") {
      this.scaricaNT9FromFE(pratica);
    } else if (tipoDocumento === "FOTO ROUTER") {
      this.scaricaFotoRouter(pratica);
    } else if (tipoDocumento === "ALTRO") {
      this.scaricaAltriFile(pratica);
    }
  }
  async scaricaAltriFile(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/altro/`;
    try {
      const folderRef = ref(storage, folderPath);

      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        const filePath = folderPath + "/" + fileRef;
        const fileReference = ref(storage, filePath);
        const blobFile = await getBlob(fileReference);
        saveAs(blobFile, fileRef);
      }

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  openGis2Web(pratica: PraticaFlowdy2_Firestore) {
    window.open("https://nt9convergo-cloud.maphosting.it/", "_blank");
  }

  async rigeneraDocs(pratica: PraticaFlowdy2_Firestore) {
    let messaggio: string =
      "Confermi di voler RIGENERARE tutta la documentazione della pratica " +
      pratica.cui;
    if (pratica.colocata) {
      let colocate: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
          pratica.cui,
          pratica.codiceInvio,
        );
      messaggio += " e delle pratiche colocate: ";
      if (colocate.length > 0) {
        messaggio += colocate.map((p) => p.cui).join(", ");
      }
    }
    messaggio += "?";
    this.confirmationService.confirm({
      message: messaggio,
      header: "ATTENZIONE!",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "PROCEDI",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
        this.isLoadingResults = true;
        this.praticheService
          .rigeneraTuttaLaDocumentazione(pratica.id.valueOf())
          .subscribe({
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                life: 10000,
                detail: "Errore durante la rigenerazione della documentazione",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "",
                life: 10000,
                detail:
                  "Rigenerazione della documentazione della pratica " +
                  pratica.cui +
                  " completata con successo",
              });
            },
          });
      },
      reject: () => {},
    });
  }

  checkLavorabilitàFase3(
    praticaFromFS: PraticaFlowdy2_Firestore,
    praticaFromDB: Pratica,
  ): boolean {
    if (
      !praticaFromDB.centrale ||
      !praticaFromDB.centrale.clli ||
      !praticaFromFS.coordinateScuola
    ) {
      return false;
    }
    return true;
  }
  simpleCheckLavorabilitaFase3(
    praticaFromFS: PraticaFlowdy2_Firestore,
  ): boolean {
    if (!praticaFromFS.coordinateCentrale || !praticaFromFS.coordinateScuola) {
      return false;
    }
    return true;
  }

  checkIfColocataForInfoFase3(pratica: PraticaFlowdy2_Firestore): boolean {
    if (!pratica.colocata) {
      this.logger.info(
        "checkIfColocataForInfoFase3 ---> " + pratica.cui + " NON COLOCATA ",
      );

      return false;
    } else {
      if (pratica.colocataRuolo === "PRINCIPALE") {
        if (this.checkCodiceInvioUgualeColocate(pratica)) {
          this.logger.info(
            "checkIfColocataForInfoFase3 ---> " +
              pratica.cui +
              " PRINCIPALE STESSO CODICE INVIO - COLOCATA",
          );
          return true;
        } else {
          this.logger.info(
            "checkIfColocataForInfoFase3 ---> " +
              pratica.cui +
              " PRINCIPALE DIVERSO CODICE INVIO - NON COLOCATA",
          );
          return false;
        }
        //return true;
      } else if (pratica.colocataRuolo === "SECONDARIA") {
        if (this.checkCodiceInvioUgualeColocate(pratica)) {
          this.logger.info(
            "checkIfColocataForInfoFase3 ---> " +
              pratica.cui +
              " SECONDARIA STESSO CODICE INVIO - COLOCATA",
          );
          return true;
        } else {
          this.logger.info(
            "checkIfColocataForInfoFase3 ---> " +
              pratica.cui +
              " SECONDARIA DIVERSO CODICE INVIO - NON COLOCATA",
          );
          return false;
        }
      }
    }
    return false;
  }

  openInserisciDettagli(praticaFromFirestore: PraticaFlowdy2_Firestore): void {
    let praticaDaAggiornare: PraticaScuola;
    let scuolaDaAggiornare: ScuolaDTO;
    this.isLoadingResults = true;
    this.praticheService
      .getById(praticaFromFirestore.id.toString())
      .subscribe((pratica) => {
        this.isLoadingResults = false;
        praticaDaAggiornare = pratica;
        const isTipoCy =
          praticaFromFirestore.tipoSedeEffettiva === "Cy" ||
          praticaFromFirestore.tipoSede === "Cy";
        if (
          !praticaFromFirestore.coordinateScuola ||
          (!isTipoCy && (!pratica.centrale || !pratica.centrale.clli))
        ) {
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            life: 10000,
            detail: [
              "Impossibile inserire i dati di fase 3 della pratica " +
                pratica.cui +
                (isTipoCy
                  ? " poichè non sono presenti i dati della scuola."
                  : " poichè non sono presenti i dati della centrale o della scuola."),
              this.isImpresa
                ? "Contattare gli amministratori del sistema"
                : "Completare le informazioni tramite la funzione MODIFICA",
            ].join("\n"),
          });
        } else {
          this.scuoleService
            .getById(praticaDaAggiornare.scuola.id.toString())
            .subscribe((scuola) => {
              this.isLoadingResults = false;
              scuolaDaAggiornare = scuola;
              this.ref = this.dialogService.open(
                DialogInformazioniFase3Bando2,
                {
                  data: {
                    pratica: praticaDaAggiornare,
                    praticaFromFirestore: praticaFromFirestore,
                    //pratiche:             this.pratiche,
                    scuola: scuolaDaAggiornare,
                    isColocata:
                      this.checkIfColocataForInfoFase3(praticaFromFirestore),
                  },
                  header: "Dettagli Pratica " + pratica.cui,
                  width: "85%",
                  height: "85%",
                  baseZIndex: 10000,
                  closable: true,
                  draggable: false,
                },
              );
              this.ref.onClose.subscribe((infoUpdated) => {
                if (infoUpdated && infoUpdated.success) {
                }
              });
            });
        }
      });
  }

  openIniziaProgettazione(pratica: PraticaFlowdy2_Firestore): void {
    if (!pratica.coordinateScuola) {
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        life: 10000,
        detail:
          "Impossibile iniziare la progettazione della pratica " +
          pratica.cui +
          " poichè non sono presenti le coordinate della scuola.",
      });
      return;
    } else {
      this.showIniziaProgettazione = true;
      this.selectedPratica = pratica;
    }
  }

  confermaInizioProgettazione() {
    this.isLoadingResults = true;
    this.praticheService
      .iniziaProgettazione(this.selectedPratica.id)
      .subscribe({
        next: (v) => {},
        error: (e) => {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            life: 10000,
            detail: "Errore in fase di inizio progettazione della pratica",
          });
          this.isLoadingResults = false;
        },
        complete: () => {
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "",
            life: 10000,
            detail: "Inizio progettazione avvenuto con successo",
          });
        },
      });
    this.showIniziaProgettazione = false;
    this.selectedPratica = null;
  }

  modificaModelloSUBIRU(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message:
        "Confermi di voler usare il modello SUBIRU PRESCORPORO per la pratica " +
        pratica.cui +
        "?",
      header: "MODELLO SUBIRU PRESCORPORO",
      icon: "pi pi-angle-double-left",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService
          .modificaModelloSUBIRU(pratica.id as number)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di modifica del modello SUBIRU",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "",
                life: 10000,
                detail: "Modello SUBIRU utilizzato modificato con successo",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  ripristinaModelloSUBIRU(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message:
        "Confermi di voler RIPRISTINARE l'utilizzo del modello SUBIRU corrente per la pratica " +
        pratica.cui +
        "?",
      header: "RIPRISTINA MODELLO SUBIRU CORRENTE",
      icon: "pi pi-angle-double-right",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService
          .modificaModelloSUBIRU(pratica.id as number)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di ripristino del modello SUBIRU",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "",
                life: 10000,
                detail: "Modello SUBIRU corrente ripristinato con successo",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  modificaModelloIRU(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message:
        "Confermi di voler usare il vecchio modello IRU per la pratica " +
        pratica.cui +
        "?",
      header: "MODELLO IRU",
      icon: "pi pi-arrow-circle-left",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService
          .modificaModelloIRU(pratica.id as number)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di modifica del modello IRU",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "",
                life: 10000,
                detail: "Modello IRU utilizzato modificato con successo",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  ripristinaModelloIRU(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message:
        "Confermi di voler RIPRISTINARE l'utilizzo del modello IRU corrente per la pratica " +
        pratica.cui +
        "?",
      header: "RIPRISTINA MODELLO IRU CORRENTE",
      icon: "pi pi-arrow-circle-right",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService
          .modificaModelloIRU(pratica.id as number)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di ripristino del modello IRU",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "",
                life: 10000,
                detail: "Modello IRU corrente ripristinato con successo",
              });
            },
          });
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  openModificaPraticaDialog(
    praticaFromFirestore: PraticaFlowdy2_Firestore,
  ): void {
    let praticaDaAggiornare: PraticaScuola;
    let scuolaDaAggiornare: ScuolaDTO;
    this.praticheService
      .getById(praticaFromFirestore.id.toString())
      .subscribe((pratica) => {
        praticaDaAggiornare = pratica;
        //this.logger.info(praticaDaAggiornare);
        this.scuoleService
          .getById(praticaDaAggiornare.scuola.id.toString())
          .subscribe((scuola) => {
            scuolaDaAggiornare = scuola;
            //this.logger.info(scuola);
            this.ref = this.dialogService.open(ModificaPratica, {
              data: {
                pratica: praticaDaAggiornare,
                praticaFromFirestore: praticaFromFirestore,
                scuola: scuolaDaAggiornare,
              },
              header: "Modifica la pratica " + pratica.cui,
              width: "85%",
              height: "85%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((infoUpdated) => {
              if (infoUpdated && infoUpdated.success) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  life: 10000,
                  detail: "Praticha modificata con successo",
                });
              }
            });
          });
      });
    // =    praticaDaAggiornare.cui = pratica.cui;
    //    praticaDaAggiornare.id = pratica.id;
  }

  showInfoFase3Complete(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
      pratica.infoCompleted
    ) {
      return true;
    }
    return false;
  }

  showVerbaleWifiUploaded(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.wifi && pratica.verbaleWifiUploaded) {
      return true;
    }
    return false;
  }

  showAltriFileUploaded(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      this.isPresidioSF &&
      (pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") &&
      pratica.fileAltriUploadedFase3
    ) {
      return true;
    }
    return false;
  }

  visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;

    this.praticheService.getNote(pratica.id).subscribe((notePratica) => {
      this.isLoadingResults = false;
      this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
        data: {
          pratica: pratica,
          note: notePratica,
        },
        header: "NOTE della pratica " + pratica.cui,
        width: "50%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    });
  }

  openMappaConScuola(pratica: PraticaFlowdy2_Firestore) {
    this.praticheService
      .getById(pratica.id.toString())
      .subscribe((praticaCompleta) => {
        this.ref = this.dialogService.open(PosizioneScuola, {
          data: {
            pratica: pratica,
            praticaCompleta: praticaCompleta,
          },
          header: "Posizione della scuola e della centrale assegnata",
          width: "70%",
          height: "75%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      });
  }

  comunicaInvioInfratelPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogInvioInfratel, {
      data: {
        pratica: pratica,
        fase: 3,
      },
      header:
        "Comunicazione invio ad INFRATEL della FASE 3 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((invioFase1) => {
      if (invioFase1 && invioFase1.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Invio della pratica ad INFRATEL comuinicato!",
          life: 3000,
        });
      }
    });
  }
  getTooltipPenaleAttivazione(pratica: PraticaFlowdy2_Firestore) {
    let messaggio: string = "Pratica rifiutata da ";
    if (pratica.dataRispostaInfratelFase1) {
      const oggi = new Date();
      const dataRisposta = pratica.dataRispostaInfratelFase1.toDate(); // Converte il Firestore Timestamp in un oggetto Date
      const diffTime = Math.abs(oggi.getTime() - dataRisposta.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Converte il tempo in giorni
      const numeroGiorni = 90 - diffDays;

      if (numeroGiorni >= 0) {
        messaggio += `Attenzione! Mancano ${numeroGiorni} giorni alla penale riguardante l'attivazione della scuola.`;
      } else {
        messaggio += `Attenzione! La penale riguardante l'attivazione della scuola è in corso da ${Math.abs(numeroGiorni)} giorni.`;
      }
    } else {
      messaggio += "un numero sconosciuto di giorni";
    }
    return messaggio;
  }
  checkPenaleAttivazione(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.codiceStatoInfratelFase1 === "1-6" &&
      pratica.statoPF === "PRONTO"
    ) {
      const oggi = new Date();
      const dataPecODE = pratica.dataPecOde.toDate();
      const diffTime = Math.abs(oggi.getTime() - dataPecODE.getTime());
      const numeroGiorni = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (numeroGiorni >= 60) {
        return true;
      }
    }
    return false;
  }

  comunicaEsitoFase3(pratica: PraticaFlowdy2_Firestore, isApprovata: boolean) {
    if (isApprovata) {
      this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
        data: {
          pratica: pratica,
          fase: 3,
        },
        header:
          "Accettazione della FASE 3 della pratica " +
          pratica.cui.toUpperCase(),
        width: "50%",
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Accettazione della FASE 3 della pratica comuinicata!",
            life: 3000,
          });
        }
      });
    } else {
      this.ref = this.dialogService.open(ComunicaBocciatura, {
        data: {
          pratica: pratica,
          fase: 3,
        },
        header:
          "Indica le moditivazioni della bocciatura della FASE 3 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Bocciatura pratica comuinicata!",
            life: 3000,
          });
        }
      });
    }
  }

  async scaricaNT9(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    const pathReferenceNT9 = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_3/file/nt9.zip",
    );

    const blobNT9 = await getBlob(pathReferenceNT9);
    saveAs(blobNT9, "nt9.zip");
  }

  async scaricaDocs(filetype: string, pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    if (filetype === "RET") {
      const pathReferenceRET = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" +
          pratica.codiceRegione +
          "_F_RET_01_0.docx",
      );

      const blobRET = await getBlob(pathReferenceRET);
      saveAs(blobRET, pratica.codiceRegione + "_F_RET_01_0.docx");
    } else if (filetype === "PSI") {
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" +
          pratica.codiceRegione +
          "_F_PSI_02_0.docx",
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(blobPSI, pratica.codiceRegione + "_F_PSI_02_0.docx");
    } else if (filetype === "IRU") {
      if (this.escludeDocumentiIruDaPacchetto(pratica)) {
        return;
      }
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
          pratica.cui +
          ".docx",
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(blobPSI, pratica.cui + ".docx");
    } else if (filetype === "ALL") {
      if (
        !this.escludeDocumentiIruDaPacchetto(pratica) &&
        this.checkIfColocata(pratica)
      ) {
        let praticheColocate: PraticaFlowdy2_Firestore[] =
          this.getPraticheColocateDiUnaPrincipale(pratica.cui);
        for (const praticaColocata of praticheColocate) {
          this.logger.info("--> scarico gli allegati delle pratiche colocate");

          const tmpPathReferenceAllegatoIRU = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
              praticaColocata.cui +
              ".docx",
          );
          this.logger.info(
            "--> scaricaDocs ALL iru " + tmpPathReferenceAllegatoIRU.name,
          );
          const blobAllegatoIRU = await getBlob(tmpPathReferenceAllegatoIRU);
          saveAs(blobAllegatoIRU, praticaColocata.cui + ".docx");
        }
      }
      const pathReferenceRET = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" +
          pratica.codiceRegione +
          "_F_RET_01_0.docx",
      );

      this.googleStorageService
        .checkIfPraticaHasAltriFile(pratica.cui)
        .subscribe(async (risultatoCheckSuStorage) => {
          if (risultatoCheckSuStorage) {
            this.openScaricaAltriFile(pratica);
          }
        });
      const blobRET = await getBlob(pathReferenceRET);
      saveAs(blobRET, pratica.codiceRegione + "_F_RET_01_0.docx");
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" +
          pratica.codiceRegione +
          "_F_PSI_02_0.docx",
      );
      this.logger.info("--> scaricaDocs ALL psi " + pathReferencePSI.name);
      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(blobPSI, pratica.codiceRegione + "_F_PSI_02_0.docx");

      if (!this.escludeDocumentiIruDaPacchetto(pratica)) {
        const pathReferenceAllegatoIRU = ref(
          storage,
          "pratiche/scuola/" +
            pratica.cui +
            "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
            pratica.cui +
            ".docx",
        );
        this.logger.info(
          "--> scaricaDocs ALL iru " + pathReferenceAllegatoIRU.name,
        );
        const blobAllegatoIRU = await getBlob(pathReferenceAllegatoIRU);
        saveAs(blobAllegatoIRU, pratica.cui + ".docx");
      }
    }
  }

  async openScaricaAltriFile(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    this.isLoadingResults = true;

    this.googleStorageService
      .checkIfPraticaHasAltriFile(pratica.cui)
      .subscribe(async (risultatoCheckSuStorage) => {
        if (risultatoCheckSuStorage) {
          this.googleStorageService
            .downloadFolderContents(pratica.cui)
            .subscribe(
              ({ blob, fileName }) => {
                saveAs(blob, fileName);
                this.isLoadingResults = false;
              },
              (error) => {
                this.messageService.add({
                  severity: "info",
                  summary: "Errore",
                  life: 10000,
                  detail:
                    "Errore durante lo scaricamento degli altri file caricati",
                });
                this.isLoadingResults = false;
              },
            );
        } else {
          this.messageService.add({
            severity: "warn",
            summary: "Attenzione!",
            life: 10000,
            detail: "Non sono stati caricati altri file",
          });
          this.isLoadingResults = false;
        }
      });
  }

  apriNoteRespingimento(
    pratica: PraticaFlowdy2_Firestore,
    isRespigimento: boolean,
  ) {
    this.ref = this.dialogService.open(DialogNoteReworkFase3, {
      data: {
        pratica: pratica,
        isRespigimento: isRespigimento,
      },
      header:
        "Note relative al RESPINGIMENTO della FASE 3 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  rifiutaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogPresidioTIMRifiutaPratica, {
      data: {
        pratica: pratica,
        fase: "3",
      },
      header:
        "Rifiuta la consegna della FASE 3 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((rifiutoOK) => {
      if (rifiutoOK && rifiutoOK.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna rifiutata !",
          life: 3000,
        });
      }
    });
  }

  /**
   * Verifica la presenza dei file del pacchetto senza scaricarli.
   * Applicabile solo per pratiche con statoFlowdyFase3 uguale a VERBALE FIRMATO.
   */
  async verificaPresenzaFilePacchetto(
    pratica: PraticaFlowdy2_Firestore,
  ): Promise<{
    applicabile: boolean;
    tuttiPresenti?: boolean;
    risultati: {
      path: string;
      presente: boolean;
      errore?: string;
      tipo?: "principale" | "colocata";
      cuiRiferimento?: string;
    }[];
  }> {
    if (
      pratica.statoFlowdyFase3 !== "VERBALE FIRMATO" &&
      pratica.statoFlowdyFase3 !== "IN CARICO PRESIDIO"
    ) {
      return { applicabile: false, risultati: [] };
    }

    const colocateCuis: string[] = this.checkIfColocataPerPacchetto(pratica)
      ? this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
          pratica.cui,
          pratica.codiceInvio,
        ).map((c) => c.cui)
      : [];
    const cuiFromPath = (path: string): string | null => {
      const m = path.match(/pratiche\/scuola\/([^/]+)/);
      return m ? m[1] : null;
    };
    const getTipoFromPath = (
      path: string,
    ):
      | { tipo: "principale" | "colocata"; cuiRiferimento?: string }
      | undefined => {
      if (colocateCuis.length === 0) return undefined;
      const cui = cuiFromPath(path);
      if (!cui) return undefined;
      if (cui === pratica.cui) return { tipo: "principale" };
      if (colocateCuis.includes(cui))
        return { tipo: "colocata", cuiRiferimento: cui };
      return undefined;
    };

    const storage = getStorage();
    const pathReferenceNT9 = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_3/file/nt9.zip",
    );
    const pathReferenceRET = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_RET_01_0.pdf",
    );
    const pathReferencePSI = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_PSI_02_0.pdf",
    );
    const pathReferenceAllegatoIRU = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
        pratica.cui +
        ".pdf",
    );
    const pathReferenceCMT = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/IN/FASE_3/file/" +
        pratica.codiceRegione +
        "_F_CMT_03_0.xlsx",
    );
    const pathReferenceVerbaleCessioneIRU = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
        pratica.cui +
        ".pdf.p7m",
    );
    const pathReferenceVerbaleCessioneProprieta = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
        pratica.cui +
        ".pdf.p7m",
    );

    const filesToVerify: ReturnType<typeof ref>[] = [
      pathReferenceNT9,
      pathReferenceRET,
      pathReferencePSI,
      pathReferenceCMT,
    ];
    const planimetriaToVerify: { folderPath: string; label: string }[] = [];

    if (
      pratica.tipoSedeEffettiva === "B" ||
      pratica.tipoSedeEffettiva === "B*" ||
      pratica.tipoSedeEffettiva === "B**"
    ) {
      filesToVerify.push(pathReferenceAllegatoIRU);
      filesToVerify.push(pathReferenceVerbaleCessioneIRU);
      if (this.checkIfColocataPerPacchetto(pratica)) {
        const colocate = this.getPraticheColocateDiUnaPrincipale(pratica.cui);
        colocate.forEach((praticaColocata) => {
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
                praticaColocata.cui +
                ".pdf",
            ),
          );
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
                praticaColocata.cui +
                ".pdf.p7m",
            ),
          );
        });
      }
    } else if (pratica.tipoSedeEffettiva === "D") {
      filesToVerify.push(pathReferenceVerbaleCessioneIRU);
      filesToVerify.push(pathReferenceAllegatoIRU);
      filesToVerify.push(pathReferenceVerbaleCessioneProprieta);
      // Planimetria richiesta solo per tipo sede D (e per colocate D con planimetriaUploaded)
      planimetriaToVerify.push({
        folderPath: `pratiche/scuola/${pratica.cui}/IN/FASE_3`,
        label: `Planimetria (${pratica.cui})`,
      });
      if (this.checkIfColocataPerPacchetto(pratica)) {
        const colocate =
          this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
            pratica.cui,
            pratica.codiceInvio,
          );
        colocate.forEach((praticaColocata) => {
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
                praticaColocata.cui +
                ".pdf",
            ),
          );
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
                praticaColocata.cui +
                ".pdf.p7m",
            ),
          );
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
                praticaColocata.cui +
                ".pdf.p7m",
            ),
          );
          filesToVerify.push(
            ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/IN/FASE_3/file/nt9.zip",
            ),
          );
          if (praticaColocata.planimetriaUploaded) {
            planimetriaToVerify.push({
              folderPath: `pratiche/scuola/${praticaColocata.cui}/IN/FASE_3`,
              label: `Planimetria (${praticaColocata.cui})`,
            });
          }
        });
      }
    }

    const risultati: {
      path: string;
      presente: boolean;
      errore?: string;
      tipo?: "principale" | "colocata";
      cuiRiferimento?: string;
    }[] = [];

    // File ALTRO (cartella altro nel pacchetto): riga solo se presenti (non sono obbligatori)
    try {
      const hasAltriFilePrincipale = await firstValueFrom(
        this.googleStorageService.checkIfPraticaHasAltriFile(pratica.cui),
      );
      if (hasAltriFilePrincipale) {
        risultati.push({
          path: "altro:" + pratica.cui,
          presente: true,
          ...(colocateCuis.length > 0 && {
            tipo: "principale" as const,
          }),
        });
      }
    } catch {
      // non aggiungere riga se errore o assenti
    }
    if (colocateCuis.length > 0) {
      const colocate =
        this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
          pratica.cui,
          pratica.codiceInvio,
        );
      for (const praticaColocata of colocate) {
        try {
          const hasAltriFile = await firstValueFrom(
            this.googleStorageService.checkIfPraticaHasAltriFile(
              praticaColocata.cui,
            ),
          );
          if (hasAltriFile) {
            risultati.push({
              path: "altro:" + praticaColocata.cui,
              presente: true,
              tipo: "colocata",
              cuiRiferimento: praticaColocata.cui,
            });
          }
        } catch {
          // non aggiungere riga se errore o assenti
        }
      }
    }

    for (const pathRef of filesToVerify) {
      const path = pathRef.fullPath;
      const tipoInfo = getTipoFromPath(path);
      try {
        await getMetadata(pathRef);
        risultati.push({
          path,
          presente: true,
          ...(tipoInfo && {
            tipo: tipoInfo.tipo,
            cuiRiferimento: tipoInfo.cuiRiferimento,
          }),
        });
      } catch (err: any) {
        risultati.push({
          path,
          presente: false,
          errore: err?.code || err?.message || String(err),
          ...(tipoInfo && {
            tipo: tipoInfo.tipo,
            cuiRiferimento: tipoInfo.cuiRiferimento,
          }),
        });
      }
    }

    for (const { folderPath, label } of planimetriaToVerify) {
      const path = folderPath + " [" + label + "]";
      const tipoInfo = getTipoFromPath(folderPath);
      try {
        const folderRef = ref(storage, folderPath);
        const fileList = await listAll(folderRef);
        const planimetriaFiles = fileList.items.filter((item) =>
          item.name.toUpperCase().startsWith("PLANIMETRIA"),
        );
        risultati.push({
          path,
          presente: planimetriaFiles.length > 0,
          ...(tipoInfo && {
            tipo: tipoInfo.tipo,
            cuiRiferimento: tipoInfo.cuiRiferimento,
          }),
        });
      } catch (err: any) {
        risultati.push({
          path,
          presente: false,
          errore: err?.code || err?.message || String(err),
          ...(tipoInfo && {
            tipo: tipoInfo.tipo,
            cuiRiferimento: tipoInfo.cuiRiferimento,
          }),
        });
      }
    }

    // Per tuttiPresenti si considerano solo i file obbligatori (esclusa la riga ALTRO, che è informativa)
    const tuttiPresenti = risultati
      .filter((r) => !r.path.startsWith("altro:"))
      .every((r) => r.presente);
    return {
      applicabile: true,
      tuttiPresenti,
      risultati,
    };
  }

  /** Restituisce l'etichetta da mostrare in modale per un path del risultato verifica pacchetto. */
  getLabelVerificaPacchetto(path: string): string {
    if (!path) return path;
    if (path.startsWith("altro:")) return "ALTRO";
    if (path.includes("nt9.zip")) return "PACCHETTO NT9";
    if (path.includes("_F_RET_01_0.pdf")) return "RET";
    if (path.includes("_F_PSI_02_0.pdf")) return "PSI";
    if (path.includes("_F_CMT_03_0.xlsx")) return "COMPUTO METRICO";
    if (
      path.includes("ALLEGATO CONTRATTO IRU") ||
      path.includes("ALLEGATO CONTRATTO SUBIRU")
    )
      return "ALLEGATO IRU";
    if (path.includes("Contratto_Cessione_Proprieta"))
      return "VERBALE CESSIONE PROPRIETÀ";
    if (path.includes("Contratto_Cessione_IRU"))
      return "VERBALE CESSIONE IRU (firmato)";
    if (path.includes("Planimetria")) return "PLANIMETRIA";
    return path.split("/").pop() || path;
  }

  /** Apre la modale con l'esito della verifica presenza file pacchetto per la pratica. */
  async openVerificaFilePacchettoModal(
    pratica: PraticaFlowdy2_Firestore,
  ): Promise<void> {
    this.verificaPacchettoModalPratica = pratica;
    this.verificaPacchettoModalEsito = null;
    this.showVerificaPacchettoModal = true;
    this.isVerificaPacchettoModalLoading = true;
    try {
      const esito = await this.verificaPresenzaFilePacchetto(pratica);
      this.verificaPacchettoModalEsito = esito;
    } finally {
      this.isVerificaPacchettoModalLoading = false;
    }
  }

  async scaricaPacchettoDaStorage(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info("** scaricaPacchettoDaStorage **");
    this.isLoadingResults = true;
    const storage = getStorage();
    const zipNT9 = new JSZip();
    const zip = new JSZip();

    let cpeInStessoLocale = false;

    // Per pratiche di tipo D con pacchetto colocato, eseguo prima una get puntuale sulla pratica principale
    if (
      pratica.tipoSedeEffettiva === "D" &&
      this.checkIfColocataPerPacchetto(pratica)
    ) {
      try {
        const praticaCompleta = await firstValueFrom(
          this.praticheService.getById(pratica.id.toString()),
        );
        const scuola = await firstValueFrom(
          this.scuoleService.getById(praticaCompleta.scuola.id.toString()),
        );
        if (scuola.cpeInStessoLocale) {
          this.logger.info(
            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO D - cpeInStessoLocale = true",
          );
          cpeInStessoLocale = true;
        } else {
          this.logger.info(
            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO D - cpeInStessoLocale = false",
          );
        }
      } catch (err) {
        this.logger.error(
          "[FASE 3 BANDO 2] Errore getById pratica/scuola principale prima scaricaPacchettoDaStorage",
          err,
        );
      }
    } else {
      this.logger.info(
        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: pratica non di tipo D o non colocata",
      );
    }

    const pathReferenceNT9 = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_3/file/nt9.zip",
    );
    const pathReferenceRET = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_RET_01_0.pdf",
    );
    const pathReferencePSI = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/" +
        pratica.codiceRegione +
        "_F_PSI_02_0.pdf",
    );
    const pathReferenceAllegatoIRU = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
        pratica.cui +
        ".pdf",
    );
    const pathReferenceCMT = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/IN/FASE_3/file/" +
        pratica.codiceRegione +
        "_F_CMT_03_0.xlsx",
    );
    const pathReferenceVerbaleCessioneIRU = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
        pratica.cui +
        ".pdf.p7m",
    );
    const pathReferenceVerbaleCessioneProprieta = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/OUT/FASE3/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
        pratica.cui +
        ".pdf.p7m",
    );
    // const pathReferencePlanimetria                = ref( storage, "pratiche/scuola/" + pratica.cui +  "/IN/FASE_3/PLAN" +pratica.estensionePlanimetria);

    let filesToDownload = [
      pathReferenceNT9,
      pathReferenceRET,
      pathReferencePSI,
      pathReferenceCMT,
    ];
    if (
      pratica.tipoSedeEffettiva === "B" ||
      pratica.tipoSedeEffettiva === "B*" ||
      pratica.tipoSedeEffettiva === "B**"
    ) {
      this.logger.info(
        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO B, B* o B**",
      );
      filesToDownload.push(pathReferenceAllegatoIRU);
      filesToDownload.push(pathReferenceVerbaleCessioneIRU);

      if (this.checkIfColocataPerPacchetto(pratica)) {
        /*  this.logger.info(
          "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO B o B* - COLOCATA",
        ); */
        let colocate: PraticaFlowdy2_Firestore[] =
          //  this.getPraticheColocateDiUnaPrincipale(pratica.cui);
          //   this.logger.info(colocate);
          this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
            pratica.cui,
            pratica.codiceInvio,
          );

        colocate.forEach((praticaColocata) => {
          this.logger.info(
            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: COLOCATA: " +
              praticaColocata.cui +
              " - codice invio: " +
              praticaColocata.codiceInvio,
          );
          if (praticaColocata.codiceInvio === pratica.codiceInvio) {
            this.logger.info(
              "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: COLOCATA: " +
                praticaColocata.cui +
                " - LA AGGIUNGO: " +
                praticaColocata.codiceInvio,
            );
            const pathReferenceAllegatoIRUColocata = ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
                praticaColocata.cui +
                ".pdf",
            );
            const pathReferenceVerbaleCessioneIRUColocata = ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
                praticaColocata.cui +
                ".pdf.p7m",
            );
            const pathReferenceNT9Colocata = ref(
              storage,
              "pratiche/scuola/" +
                praticaColocata.cui +
                "/IN/FASE_3/file/nt9.zip",
            );
            this.logger.info(
              "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO B o B* CON COLOCATA: " +
                praticaColocata.cui,
            );
            filesToDownload.push(pathReferenceAllegatoIRUColocata);
            filesToDownload.push(pathReferenceVerbaleCessioneIRUColocata);
            filesToDownload.push(pathReferenceNT9Colocata);
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: COLOCATA: " +
                praticaColocata.cui +
                " - NON DOVREI AGGIUNGERLA: " +
                praticaColocata.codiceInvio,
            );
          }
        });
      } else {
        this.logger.info(
          "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO B o B* - NON COLOCATA",
        );
      }
    } else if (pratica.tipoSedeEffettiva === "D") {
      this.logger.info(
        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO D",
      );
      //todo: aggiungere file per tipo sede D
      filesToDownload.push(pathReferenceVerbaleCessioneIRU);
      filesToDownload.push(pathReferenceAllegatoIRU);
      filesToDownload.push(pathReferenceVerbaleCessioneProprieta);
      const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3`;
      try {
        const folderRef = ref(storage, folderPath);
        const fileList = await listAll(folderRef);
        const planimetriaFiles = fileList.items.filter((item) =>
          item.name.toUpperCase().startsWith("PLANIMETRIA"),
        );

        if (planimetriaFiles.length === 0) {
          throw new Error("Nessuna planimetria trovata");
        }

        const fileRef = planimetriaFiles[0];
        const filePath = `${folderPath}/${fileRef.name}`;

        const fileReference = ref(storage, filePath);
        const blobFile = await getBlob(fileReference);
        zip
          .folder(
            pratica.codiceInvio +
              "/" +
              pratica.cui +
              "/" +
              pratica.codiceRegione +
              "_F_ANN_05_0/documentazione fotografica",
          )
          .file(fileRef.name, blobFile);

        //filesToDownload.push(fileReference );
      } catch (error) {
        this.logger.error(
          "Errore durante il download della planimetria: " + error,
        );
      }

      if (this.checkIfColocataPerPacchetto(pratica)) {
        let colocate: PraticaFlowdy2_Firestore[] =
          //this.getPraticheColocateDiUnaPrincipale(pratica.cui);
          this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
            pratica.cui,
            pratica.codiceInvio,
          );

        colocate.forEach(async (praticaColocata) => {
          const pathReferenceAllegatoIRUColocata = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/OUT/FASE3/ALLEGATO CONTRATTO IRU_" +
              praticaColocata.cui +
              ".pdf",
          );
          const pathReferenceVerbaleCessioneIRUColocata = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/OUT/FASE3/SIGNED/Contratto_Cessione_IRU_" +
              praticaColocata.cui +
              ".pdf.p7m",
          );
          const pathReferenceVerbaleCessioneProprietaColocata = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/OUT/FASE3/SIGNED/Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
              praticaColocata.cui +
              ".pdf.p7m",
          );
          const pathReferenceNT9Colocata = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/IN/FASE_3/file/nt9.zip",
          );
          this.logger.info(
            praticaColocata.cui +
              " --> TIPO D COLOCATA: DOVREI SCARICARE VERBALE CESSIONE IRU: " +
              pathReferenceAllegatoIRUColocata,
          );

          filesToDownload.push(pathReferenceAllegatoIRUColocata);
          filesToDownload.push(pathReferenceVerbaleCessioneIRUColocata);
          // Se CPE è nello stesso locale, carico un solo file Proprieta (solo principale),
          // quindi non aggiungo i Contratto_Cessione_Proprieta_Nuove_Infrastrutture_* delle colocate
          if (!cpeInStessoLocale) {
            this.logger.info(
              praticaColocata.cui +
                " --> TIPO D COLOCATA CON CPE NON IN STESSO LOCALE: SCARICO VERBALE PROPRIETA: ",
            );
            filesToDownload.push(pathReferenceVerbaleCessioneProprietaColocata);
          } else {
            this.logger.info(
              praticaColocata.cui +
                " --> TIPO D COLOCATA CON CPE IN STESSO LOCALE: NON SCARICO VERBALE PROPRIETA: ",
            );
          }
          filesToDownload.push(pathReferenceNT9Colocata);
          // Se CPE è nello stesso locale, uso solo la planimetria della principale
          if (!cpeInStessoLocale && praticaColocata.planimetriaUploaded) {
            const folderPath = `pratiche/scuola/${praticaColocata.cui}/IN/FASE_3`;
            try {
              const folderRef = ref(storage, folderPath);
              const fileList = await listAll(folderRef);
              const planimetriaFiles = fileList.items.filter((item) =>
                item.name.toUpperCase().startsWith("PLANIMETRIA"),
              );

              if (planimetriaFiles.length === 0) {
                throw new Error("Nessuna planimetria trovata");
              }

              const fileRef = planimetriaFiles[0];
              const filePath = `${folderPath}/${fileRef.name}`;

              const fileReference = ref(storage, filePath);
              const blobFile = await getBlob(fileReference);
              zip
                .folder(
                  pratica.codiceInvio +
                    "/" +
                    praticaColocata.cui +
                    "/" +
                    pratica.codiceRegione +
                    "_F_ANN_05_0/documentazione fotografica",
                )
                .file(fileRef.name, blobFile);

              //filesToDownload.push(fileReference );
            } catch (error) {
              this.logger.error(
                "Errore durante il download della planimetria: " + error,
              );
            }
          }
        });
      }
    } else if (
      this.checkIfColocataPerPacchetto(pratica) &&
      this.escludeDocumentiIruDaPacchetto(pratica)
    ) {
      this.logger.info(
        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: PRINCIPALE DI TIPO A/C/Cy - COLOCATA",
      );
      const colocate =
        this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
          pratica.cui,
          pratica.codiceInvio,
        );

      colocate.forEach((praticaColocata) => {
        if (praticaColocata.codiceInvio === pratica.codiceInvio) {
          this.logger.info(
            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: COLOCATA A/C/Cy: " +
              praticaColocata.cui,
          );
          const pathReferenceNT9Colocata = ref(
            storage,
            "pratiche/scuola/" +
              praticaColocata.cui +
              "/IN/FASE_3/file/nt9.zip",
          );
          filesToDownload.push(pathReferenceNT9Colocata);
        }
      });
    }

    this.logger.info(
      "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: FILES DA SCARICARE:\n" +
        filesToDownload.map((file) => file.fullPath).join("\n"),
    );

    const downloadPromises = [];
    for (const pathRef of filesToDownload) {
      try {
        const blob = await getBlob(pathRef);

        if (blob) {
          this.logger.info(
            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: SCARICO FILE: " +
              pathRef.fullPath,
          );
          switch (pathRef.name) {
            case "nt9.zip":
              if (pathRef.fullPath.includes(pratica.cui)) {
                zip
                  .folder(
                    pratica.codiceInvio +
                      "/" +
                      pratica.cui +
                      "/" +
                      pratica.codiceRegione +
                      "_F_SHP_04_0",
                  )
                  .file(
                    "AB_" +
                      pratica.cui.substring(10, pratica.cui.length) +
                      ".zip",
                    blob,
                  );
                this.logger.info(
                  "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: OK SCARICAMENTO FILE NT9 DELLA PRINCIPALE: " +
                    pathRef.fullPath +
                    " per la pratica " +
                    pratica.cui,
                );
              } else {
                this.logger.info(
                  "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: FILE NT9 DELLA COLOCATA: " +
                    pathRef.fullPath,
                );
              }

              break;
            case `ALLEGATO CONTRATTO IRU_${pratica.cui}.pdf`:
              let allegatoSubIRUFileName: string = "ALLEGATO CONTRATTO ";
              if (pratica.usaVecchioModelloIRU) {
                allegatoSubIRUFileName += "IRU_" + pratica.cui + ".pdf";
              } else {
                allegatoSubIRUFileName += "SUBIRU_" + pratica.cui + ".pdf";
              }
              zip
                .folder(
                  pratica.codiceInvio +
                    "/" +
                    pratica.cui +
                    "/" +
                    pratica.codiceRegione +
                    "_F_ANN_05_0/contratto di cessione",
                )
                .file(allegatoSubIRUFileName, blob);
              /*   this.logger.info(
                "--> ok scaricamento ALLEGATO CONTRATTO IRU rinominato in " +
                  allegatoSubIRUFileName,
              ); */
              break;

            case `Contratto_Cessione_IRU_${pratica.cui}.pdf.p7m`:
              let contrattoSubIRUFileName: string = "Contratto_Cessione_";
              if (pratica.usaVecchioModelloIRU) {
                contrattoSubIRUFileName += "IRU_" + pratica.cui + ".pdf.p7m";
              } else {
                contrattoSubIRUFileName += "SUBIRU_" + pratica.cui + ".pdf.p7m";
              }
              zip
                .folder(
                  pratica.codiceInvio +
                    "/" +
                    pratica.cui +
                    "/" +
                    pratica.codiceRegione +
                    "_F_ANN_05_0/contratto di cessione",
                )
                .file(contrattoSubIRUFileName, blob);
              /*   this.logger.info(
                "--> ok scaricamento Contratto_Cessione_IRU_ rinominato in " +
                  contrattoSubIRUFileName,
              ); */
              break;
            case "Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
              pratica.cui +
              ".pdf.p7m":
              zip
                .folder(
                  pratica.codiceInvio +
                    "/" +
                    pratica.cui +
                    "/" +
                    pratica.codiceRegione +
                    "_F_ANN_05_0/contratto di cessione",
                )
                .file(
                  "Contratto_Cessione_Proprietà_Nuove_Infrastrutture_" +
                    pratica.cui +
                    ".pdf.p7m",
                  blob,
                );
              //    this.logger.info("--> ok scaricamento file "+pathRef.name);
              break;
            case `${pratica.codiceRegione}_F_PSI_02_0.pdf`:
              zip.file(
                `${pratica.codiceInvio}/${pratica.codiceRegione}_F_PSI_02_0.pdf`,
                blob,
              );
              //  this.logger.info("--> ok scaricamento file "+pathRef.name);
              break;
            case `${pratica.codiceRegione}_F_RET_01_0.pdf`:
              zip.file(
                `${pratica.codiceInvio}/${pratica.codiceRegione}_F_RET_01_0.pdf`,
                blob,
              );
              //  this.logger.info("--> ok scaricamento file "+pathRef.name);
              break;
            case `${pratica.codiceRegione}_F_CMT_03_0.xlsx`:
              zip.file(
                `${pratica.codiceInvio}/${pratica.codiceRegione}_F_CMT_03_0.xlsx`,
                blob,
              );
              //    this.logger.info("--> ok scaricamento file "+pathRef.name);
              break;
            default:
              //zip.file(pathRef.name, blob);
              break;
          }
          if (this.checkIfColocataPerPacchetto(pratica)) {
            let colocate: PraticaFlowdy2_Firestore[] =
              //this.getPraticheColocateDiUnaPrincipale(pratica.cui);
              this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
                pratica.cui,
                pratica.codiceInvio,
              );
            colocate.forEach((praticaColocata) => {
              if (praticaColocata.codiceInvio === pratica.codiceInvio) {
                switch (pathRef.name) {
                  case "nt9.zip":
                    if (pathRef.fullPath.includes(praticaColocata.cui)) {
                      zip
                        .folder(
                          pratica.codiceInvio +
                            "/" +
                            praticaColocata.cui +
                            "/" +
                            praticaColocata.codiceRegione +
                            "_F_SHP_04_0",
                        )
                        .file(
                          "AB_" +
                            praticaColocata.cui.substring(
                              10,
                              praticaColocata.cui.length,
                            ) +
                            ".zip",
                          blob,
                        );
                      this.logger.info(
                        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: OK SCARICAMENTO FILE NT9 DELLA COLOCATA: " +
                          pathRef.fullPath,
                      );
                    } else {
                      this.logger.info(
                        "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: FILE NT9 DELLA COLOCATA: " +
                          pathRef.fullPath,
                      );
                    }
                    break;
                  case `ALLEGATO CONTRATTO IRU_${praticaColocata.cui}.pdf`:
                    let allegatoSubIRUFileName: string = "ALLEGATO CONTRATTO ";
                    if (praticaColocata.usaVecchioModelloIRU) {
                      allegatoSubIRUFileName +=
                        "IRU_" + praticaColocata.cui + ".pdf";
                    } else {
                      allegatoSubIRUFileName +=
                        "SUBIRU_" + praticaColocata.cui + ".pdf";
                    }
                    zip
                      .folder(
                        pratica.codiceInvio +
                          "/" +
                          praticaColocata.cui +
                          "/" +
                          praticaColocata.codiceRegione +
                          "_F_ANN_05_0/contratto di cessione",
                      )
                      .file(allegatoSubIRUFileName, blob);
                    break;

                  case `Contratto_Cessione_IRU_${praticaColocata.cui}.pdf.p7m`:
                    let contrattoSubIRUFileName: string = "Contratto_Cessione_";
                    if (praticaColocata.usaVecchioModelloIRU) {
                      contrattoSubIRUFileName +=
                        "IRU_" + praticaColocata.cui + ".pdf.p7m";
                    } else {
                      contrattoSubIRUFileName +=
                        "SUBIRU_" + praticaColocata.cui + ".pdf.p7m";
                    }
                    zip
                      .folder(
                        pratica.codiceInvio +
                          "/" +
                          praticaColocata.cui +
                          "/" +
                          praticaColocata.codiceRegione +
                          "_F_ANN_05_0/contratto di cessione",
                      )
                      .file(contrattoSubIRUFileName, blob);
                    break;
                  case "Contratto_Cessione_Proprieta_Nuove_Infrastrutture_" +
                    praticaColocata.cui +
                    ".pdf.p7m":
                    zip
                      .folder(
                        pratica.codiceInvio +
                          "/" +
                          praticaColocata.cui +
                          "/" +
                          praticaColocata.codiceRegione +
                          "_F_ANN_05_0/contratto di cessione",
                      )
                      .file(
                        "Contratto_Cessione_Proprietà_Nuove_Infrastrutture_" +
                          praticaColocata.cui +
                          ".pdf.p7m",
                        blob,
                      );
                    break;
                  default:
                    //zip.file(pathRef.name, blob);
                    break;
                }
              }
            });
          }
          downloadPromises.push(Promise.resolve());
        } else {
          this.logger.error(`Errore durante il download di ${pathRef.name}`);
        }
      } catch (error) {
        this.isLoadingResults = false;
        this.logger.info(pathRef.name);
        if (pathRef.name.endsWith(".xlsx")) {
        } else {
          if (error.code === "storage/object-not-found") {
            this.logger.error("Il file non esiste:", error.message);
            this.messageService.add({
              severity: "info",
              summary: "Errore",
              life: 10000,
              detail: "Il file " + error.message + " non esiste",
            });
          } else {
            // Gestisci altri tipi di errori
            this.logger.info("Errore sconosciuto:", error);
          }
        }
      }
    }
    this.logger.info(
      "--> FINE SCARICAMENTO DEI FILE INIZIO CREAZIONE ZIP: la reputa colocata? " +
        this.checkIfColocata(pratica),
    );

    Promise.all(downloadPromises)
      .then(() => {
        zip.folder(
          pratica.codiceInvio +
            "/" +
            pratica.cui +
            "/" +
            pratica.codiceRegione +
            "_F_ANN_05_0/documentazione fotografica",
        );
        zip.folder(
          pratica.codiceInvio +
            "/" +
            pratica.cui +
            "/" +
            pratica.codiceRegione +
            "_F_ANN_05_0/istanze_autorizzazioni",
        );
        zip.folder(
          pratica.codiceInvio +
            "/" +
            pratica.cui +
            "/" +
            pratica.codiceRegione +
            "_F_ANN_05_0/misure ottiche (eventuale)",
        );
        if (pratica.colocata && this.checkIfColocataPerPacchetto(pratica)) {
          let colocate: PraticaFlowdy2_Firestore[] =
            //this.getPraticheColocateDiUnaPrincipale(pratica.cui);
            this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
              pratica.cui,
              pratica.codiceInvio,
            );

          colocate.forEach((praticaColocata) => {
            if (praticaColocata.codiceInvio === pratica.codiceInvio) {
              zip.folder(
                pratica.codiceInvio +
                  "/" +
                  praticaColocata.cui +
                  "/" +
                  praticaColocata.codiceRegione +
                  "_F_ANN_05_0/documentazione fotografica",
              );
              zip.folder(
                pratica.codiceInvio +
                  "/" +
                  praticaColocata.cui +
                  "/" +
                  praticaColocata.codiceRegione +
                  "_F_ANN_05_0/istanze_autorizzazioni",
              );
              zip.folder(
                pratica.codiceInvio +
                  "/" +
                  praticaColocata.cui +
                  "/" +
                  praticaColocata.codiceRegione +
                  "_F_ANN_05_0/misure ottiche (eventuale)",
              );
            }
          });
          this.logger.info("--> FINE CREAZIONE ZIP PER PRATICHE COLOCATE");
        } else {
          this.logger.info("--> FINE CREAZIONE ZIP PER SINGOLA PRATICA");
        }
        this.googleStorageService
          .checkIfPraticaHasAltriFile(pratica.cui)
          .subscribe((hasAltriFile) => {
            /*   this.logger.info(
              "--> INIZIO SCARICAMENTO DEI FILE ALTRO PER SINGOLA PRATICA: hasAltriFile? " +
                hasAltriFile,
            ); */
            if (hasAltriFile) {
              /*  this.logger.info(
                "--> INIZIO SCARICAMENTO DEI FILE ALTRO PER SINGOLA PRATICA",
              ); */
              this.googleStorageService
                .getFolderContents(pratica.cui)
                .subscribe({
                  next: (files) => {
                    /*   this.logger.info(
                      "--> INIZIO SCARICAMENTO DEI FILE ALTRO PER SINGOLA PRATICA: ho trovato " +
                        files.length +
                        " file",
                    ); */
                    files.forEach((fileData) => {
                      const { blob, fileName } = fileData;
                      const fileNameOriginale = fileName;
                      /*  this.logger.info(
                        "--> SCARICATO FILE ALTRO PER SINGOLA PRATICA: " +
                          fileNameOriginale,
                      ); */

                      zip
                        .folder(
                          pratica.codiceInvio +
                            "/" +
                            pratica.cui +
                            "/" +
                            pratica.codiceRegione +
                            "_F_ANN_05_0/altro",
                        )
                        .file(fileNameOriginale, blob);
                    });
                  },
                  error: (error) => {
                    console.error(
                      "Errore durante il download dei file:",
                      error,
                    );
                  },
                  complete: () => {
                    /*  this.logger.info(
                      "--> COMPLETATO SCARICAMENTO DEI FILE ALTRO ",
                    ); */
                    if (this.checkIfColocataPerPacchetto(pratica)) {
                      /*  this.logger.info(
                        "--> INIZIO SCARICAMENTO DEI FILE ALTRO PER PRATICHE COLOCATE",
                      ); */
                      let colocate: PraticaFlowdy2_Firestore[] =
                        // this.getPraticheColocateDiUnaPrincipale(pratica.cui);
                        this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
                          pratica.cui,
                          pratica.codiceInvio,
                        );

                      colocate.forEach((praticaColocata) => {
                        if (
                          praticaColocata.codiceInvio === pratica.codiceInvio
                        ) {
                          this.logger.info(
                            "[FASE 3 BANDO 2] SCARICAMENTO PACCHETTO: COLOCATA: " +
                              praticaColocata.cui +
                              " - codice invio: " +
                              praticaColocata.codiceInvio,
                          );
                          this.googleStorageService
                            .checkIfPraticaHasAltriFile(praticaColocata.cui)
                            .subscribe((hasAltriFile) => {
                              if (hasAltriFile) {
                                this.googleStorageService
                                  .getFolderContents(praticaColocata.cui)
                                  .subscribe({
                                    next: (files) => {
                                      files.forEach((fileData) => {
                                        const { blob, fileName } = fileData;
                                        const fileNameOriginale = fileName;

                                        zip
                                          .folder(
                                            pratica.codiceInvio +
                                              "/" +
                                              praticaColocata.cui +
                                              "/" +
                                              praticaColocata.codiceRegione +
                                              "_F_ANN_05_0/altro",
                                          )
                                          .file(fileNameOriginale, blob);
                                      });
                                    },
                                    error: (error) => {
                                      console.error(
                                        "Errore durante il download dei file:",
                                        error,
                                      );
                                    },
                                    complete: () => {
                                      /*   this.logger.info(
                                      "--> COMPLETATO SCARICAMENTO DEI FILE ALTRO SU PRATICA COLOCATA",
                                    );
                                    this.logger.info(
                                      "--> INIZIO CREAZIONE ZIP",
                                    ); */
                                      zip
                                        .generateAsync({ type: "blob" })
                                        .then((blob) => {
                                          saveAs(
                                            blob,
                                            pratica.codiceInvio + ".zip",
                                          );
                                          this.isLoadingResults = false;
                                        })
                                        .catch((error) => {
                                          this.isLoadingResults = false;
                                          console.error(
                                            "Errore durante la creazione dello zip:",
                                            error,
                                          );
                                        });
                                    },
                                  });
                              } else {
                                zip.folder(
                                  pratica.codiceInvio +
                                    "/" +
                                    praticaColocata.cui +
                                    "/" +
                                    praticaColocata.codiceRegione +
                                    "_F_ANN_05_0/altro",
                                );
                                /*  this.logger.info("--> INIZIO CREAZIONE ZIP"); */
                                zip
                                  .generateAsync({ type: "blob" })
                                  .then((blob) => {
                                    saveAs(blob, pratica.codiceInvio + ".zip");
                                    this.isLoadingResults = false;
                                  })
                                  .catch((error) => {
                                    this.isLoadingResults = false;
                                    console.error(
                                      "Errore durante la creazione dello zip:",
                                      error,
                                    );
                                  });
                              }
                            });
                        }
                      });
                    } else {
                      zip
                        .generateAsync({ type: "blob" })
                        .then((blob) => {
                          saveAs(blob, pratica.codiceInvio + ".zip");
                          this.isLoadingResults = false;
                        })
                        .catch((error) => {
                          this.isLoadingResults = false;
                          console.error(
                            "Errore durante la creazione dello zip:",
                            error,
                          );
                        });
                    }
                  },
                });
            } else {
              this.logger.info(
                "--> INIZIO CREAZIONE ZIP PER SINGOLA PRATICA MA SENZA FILE ALTRO",
              );
              zip.folder(
                pratica.codiceInvio +
                  "/" +
                  pratica.cui +
                  "/" +
                  pratica.codiceRegione +
                  "_F_ANN_05_0/altro",
              );
              if (this.checkIfColocataPerPacchetto(pratica)) {
                let colocate: PraticaFlowdy2_Firestore[] =
                  //  this.getPraticheColocateDiUnaPrincipale(pratica.cui);
                  this.getPraticheColocateDiUnaPrincipaleConCodiceInvioUguale(
                    pratica.cui,
                    pratica.codiceInvio,
                  );

                colocate.forEach((praticaColocata) => {
                  if (praticaColocata.codiceInvio === pratica.codiceInvio) {
                    this.googleStorageService
                      .checkIfPraticaHasAltriFile(praticaColocata.cui)
                      .subscribe((hasAltriFile) => {
                        if (hasAltriFile) {
                          this.googleStorageService
                            .getFolderContents(praticaColocata.cui)
                            .subscribe({
                              next: (files) => {
                                files.forEach((fileData) => {
                                  const { blob, fileName } = fileData;
                                  const fileNameOriginale = fileName;

                                  zip
                                    .folder(
                                      pratica.codiceInvio +
                                        "/" +
                                        praticaColocata.cui +
                                        "/" +
                                        praticaColocata.codiceRegione +
                                        "_F_ANN_05_0/altro",
                                    )
                                    .file(fileNameOriginale, blob);
                                });
                              },
                              error: (error) => {
                                console.error(
                                  "Errore durante il download dei file:",
                                  error,
                                );
                              },
                              complete: () => {
                                /*  this.logger.info(
                                "--> COMPLETATO SCARICAMENTO DEI FILE ALTRO SU PRATICA COLOCATA",
                              ); */
                                zip
                                  .generateAsync({ type: "blob" })
                                  .then((blob) => {
                                    saveAs(blob, pratica.codiceInvio + ".zip");
                                    this.isLoadingResults = false;
                                  })
                                  .catch((error) => {
                                    this.isLoadingResults = false;
                                    console.error(
                                      "Errore durante la creazione dello zip:",
                                      error,
                                    );
                                  });
                              },
                            });
                        } else {
                          zip.folder(
                            pratica.codiceInvio +
                              "/" +
                              praticaColocata.cui +
                              "/" +
                              praticaColocata.codiceRegione +
                              "_F_ANN_05_0/altro",
                          );
                          zip
                            .generateAsync({ type: "blob" })
                            .then((blob) => {
                              saveAs(blob, pratica.codiceInvio + ".zip");
                              this.isLoadingResults = false;
                            })
                            .catch((error) => {
                              this.isLoadingResults = false;
                              console.error(
                                "Errore durante la creazione dello zip:",
                                error,
                              );
                            });
                        }
                      });
                  }
                });
              } else {
                this.logger.info(
                  "--> INIZIO CREAZIONE ZIP PER SINGOLA PRATICA MA SENZA FILE ALTRO",
                );
                zip
                  .generateAsync({ type: "blob" })
                  .then((blob) => {
                    saveAs(blob, pratica.codiceInvio + ".zip");
                    this.isLoadingResults = false;
                  })
                  .catch((error) => {
                    this.isLoadingResults = false;
                    console.error(
                      "Errore durante la creazione dello zip:",
                      error,
                    );
                  });
              }
              /* zip.generateAsync({ type: 'blob' })
            .then((blob) => {
              saveAs(blob, pratica.codiceInvio+'.zip'); 
              this.isLoadingResults = false;
            })
            .catch(error => {
              this.isLoadingResults = false;
              console.error('Errore durante la creazione dello zip:', error);
            }); */
            }
          });
      })
      .catch((error) => {
        console.error("Errore durante il download dei file:", error);
        this.isLoadingResults = false;
      });
  }

  openConcludiProgettazion(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message: `Confermi di voler concludere la progettazione della pratica ${pratica.cui}?`,
      header: "Concludi Progettazione",
      icon: "pi pi-check",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService
          .generaShape(pratica.id)
          .pipe(
            switchMap(() =>
              this.praticheService.concludiProgettazione(pratica.id),
            ),
          )
          .subscribe({
            next: (v) => {
              this.isLoadingResults = false;

              this.messageService.add({
                severity: "success",
                summary: "",
                detail: "Progettazione conclusa con successo!",
                life: 5000,
              });
            },
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                detail: "Errore durante la conclusione della progettazione",
                life: 10000,
              });
            },
          });
      },
      reject: () => {},
    });
  }
  scaricaShapefile(pratica: PraticaFlowdy2_Firestore) {
    const azione =
      pratica.nt9Uploaded === true
        ? "scaricare il pacchetto contenente gli shapefile"
        : "rigenerare e scaricare il pacchetto contenente gli shapefile";

    this.confirmationService.confirm({
      message: `Confermi di voler ${azione} della pratica ${pratica.cui}?`,
      header: "Shapefile",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;

        const sorgente$ =
          pratica.nt9Uploaded === true
            ? this.praticheService.downloadShape(pratica.id)
            : this.praticheService
                .generaShape(pratica.id)
                .pipe(
                  switchMap(() =>
                    this.praticheService.downloadShape(pratica.id),
                  ),
                );

        sorgente$.subscribe({
          next: (blob: Blob) => {
            let cuiPart = pratica.cui || pratica.id.toString();
            // Estrae la parte dopo "INF-" dal CUI (es: "I-CAL-INF-CSAA81103G-1034" -> "CSAA81103G-1034")
            if (cuiPart.includes("INF-")) {
              cuiPart = cuiPart.split("INF-")[1];
            }
            const fileName = `AB_${cuiPart}.zip`;
            const fileNameSemplice = "nt9.zip";
            saveAs(blob, fileNameSemplice);
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "",
              detail: "Shapefile scaricato con successo!",
              life: 5000,
            });
          },
          error: (error) => {
            this.isLoadingResults = false;
            this.logger.error(
              "Errore durante la generazione o il download dello shapefile:",
              error,
            );
            this.messageService.add({
              severity: "error",
              summary: "Errore",
              detail:
                "Errore durante la generazione o il download dello shapefile",
              life: 10000,
            });
          },
        });
      },
      reject: () => {
        // Utente ha annullato l'operazione
      },
    });
  }

  riapriProgettazione(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message: `Confermi di voler riaprire la progettazione della pratica ${pratica.cui}? In caso di conferma verrà eliminato il pacchetto NT9 precedentemente generato.`,
      header: "Riapri Progettazione",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
        try {
          this.isLoadingResults = true;
          const docRef = this.firestore
            .collection(this.collection_pratiche)
            .doc(pratica.cui);

          await docRef.update({ nt9Uploaded: false });

          pratica.nt9Uploaded = false;

          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "",
            detail:
              "Progettazione riaperta ed eliminato il pacchetto NT9 precedentemente generato.",
            life: 5000,
          });
        } catch (error) {
          this.isLoadingResults = false;
          this.logger.error(
            "Errore durante la riapertura della progettazione:",
            error,
          );
          this.messageService.add({
            severity: "error",
            summary: "Errore",
            detail:
              "Errore durante la riapertura della progettazione e l'eliminazione del flag NT9.",
            life: 10000,
          });
        }
      },
      reject: () => {
        // Utente ha annullato l'operazione
      },
    });
  }

  openProgettaPratica(pratica: PraticaFlowdy2_Firestore) {
    const schemaName = "tim_" + pratica.codiceMiur.toLowerCase();
    let urlViewer =
      environment.nt9ViewerUrl +
      schemaName +
      "#/map/ZOOMLAYER=Scuole&ZOOMFILTER=gid$$$EQ$$$1";
    // urlViewer+="&tokenBE="+localStorage.getItem("token");
    // urlViewer+="&idPratica="+pratica.id;

    //const urlViewer = "https://nt9convergo-viewer.maphosting.it/viewer/index.php/TimSanita/"+pratica.codiceInfratel+"#/map/ZOOMLAYER=NODI&ZOOMFILTER=gid$$$EQ$$$1";
    //const urlViewer = "https://nt9convergo-viewer.maphosting.it/viewer/index.php/TimSanita/I_TOS_123#/map/ZOOMLAYER=NODI&ZOOMFILTER=gid$$$EQ$$$1";
    this.logger.info("--> URL PROGETTAZIONE: " + urlViewer);
    // Apre il viewer in una modale invece che in una nuova tab
    this.ref = this.dialogService.open(DialogProgettaPraticaComponent, {
      data: {
        urlViewer: urlViewer,
      },
      header: "Progettazione scuola " + pratica.cui,
      width: "98%",
      height: "98%",
      baseZIndex: 10000,
      closable: true,
      draggable: true,
      maximizable: true,
      styleClass: "viewer-dialog",
    });
  }

  rigeneraDocsPraticaCompleta(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message: `Confermi di voler rigenerare la documentazione della pratica ${pratica.cui}? Questa operazione potrebbe richiedere alcuni minuti.`,
      header: "Rigenera documentazione",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        this.praticheService.rigeneraDocsPraticaCompleta(pratica.id).subscribe({
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante la rigenerazione della documentazione",
              life: 10000,
            });
          },
          complete: () => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "Rigenerazione documentazione",
              detail: "Documentazione rigenerata con successo!",
              life: 5000,
            });
          },
        });
      },
    });
  }

  async scaricaPacchettoPratica(pratica: PraticaFlowdy2_Firestore) {
    if (this.isImpresa) {
      this.scaricaPacchettoDaStorage(pratica);
    } else {
      if (pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") {
        this.confirmationService.confirm({
          message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
          header: "ATTENZIONE!",
          icon: "pi pi-exclamation-circle",
          acceptLabel: "PROCEDI",
          acceptButtonStyleClass: "p-button-success",
          rejectLabel: "ANNULLA",
          rejectButtonStyleClass: "p-button-warning",
          accept: async () => {
            this.scaricaPacchettoDaStorage(pratica);
          },
          reject: () => {},
        });
      } else {
        this.scaricaPacchettoDaStorage(pratica);
      }
    }
  }

  consegnaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showDeliverConfirmation = true;
    this.selectedPratica = pratica;
  }

  confermaConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService.consegnaFase3(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "FASE 3 della pratica consegnata!",
          life: 5000,
        });
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
        this.loadPratiche();
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di consegna della FASE 3 della pratica",
        });
        this.isLoadingResults = false;
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  apriNoteBocciaturaPresidio(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase1, {
      data: {
        pratica: pratica,
        isBocciaturaPresidio: true,
      },
      header:
        "Note indicate dal presidio per la bocciatura della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  openPrendiInCarico(pratica: PraticaFlowdy2_Firestore): void {
    this.confirmationService.confirm({
      message: `Confermi di voler prendere in carico la FASE 3 della pratica ${pratica.cui}?`,
      header: "Presa in carico",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        if (this.isImpresa) {
          let utente: Utente = new Utente();
          utente.id = Number(localStorage.getItem("idUtente"));
          this.praticheService
            .utentePrendeInCaricoFase3(this.selectedPratica.id, utente)
            .subscribe({
              next: (v) => {
                this.isLoadingResults = false;
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "Pratica presa in carico con successo!",
                  life: 5000,
                });
                this.loadPratiche();
              },
              error: (e) => {
                this.messageService.add({
                  life: 10000,
                  severity: "error",
                  summary: "Errore",
                  detail: "Errore in fase di presa in carico della pratica",
                });
                this.isLoadingResults = false;
              },
              complete: () => {},
            });
        } else if (this.isPresidioSF) {
          if (pratica.statoFlowdyFase3 === "DA ASSEGNARE") {
            let utente: Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            this.praticheService
              .utentePrendeInCaricoFase3(this.selectedPratica.id, utente)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          } else {
            this.praticheService
              .presidioPrendeInCaricoFase3(this.selectedPratica.id)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          }
        }
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  validaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogVerificaConsegnaFase3, {
      data: {
        pratica: pratica,
      },
      header:
        "Validazione della consegna della FASE 3 della pratica " +
        pratica.cui.toUpperCase(),
      width: "80%",
      height: "95%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((consegnaValidata) => {
      if (consegnaValidata && consegnaValidata.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna validata con successo!",
          life: 3000,
        });
        //qui devo chiamare per generare la documentazione
        this.loadPratiche();
      }
    });
  }

  apriNoteRework(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase2, {
      data: {
        pratica: pratica,
      },
      header:
        "Note per il REWORK della FASE 3 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }
  apriNoteTIMSupport(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase2, {
      data: {
        pratica: pratica,
        isTIMSupport: true,
      },
      header: "Note TIM SUPPORT per la pratica " + pratica.cui.toUpperCase(),
      width: "50%",
      height: "35%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  caricaDocumento(pratica: PraticaFlowdy2_Firestore, tipoDocumento: string) {
    let header = "Caricamento del Verbale di ";
    if (tipoDocumento === "CONSEGNA") {
      header += "CONSEGNA ";
    } else {
      header += "ATTIVAZIONE ";
    }
    header += " della pratica " + pratica.cui.toUpperCase();

    this.ref = this.dialogService.open(DialogCaricaPacchettoNT9, {
      data: {
        pratica: pratica,
        tipoDoc: tipoDocumento,
      },
      header: header,
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Verbale di " + tipoDocumento + " caricato con successo!",
          life: 3000,
        });
      }
    });
  }

  caricaPermesso(pratica: PraticaFlowdy2_Firestore) {
    let header = "Caricamento del PERMESSO ENTE PUBBLICO ";
    header += " per la pratica " + pratica.cui.toUpperCase();

    this.ref = this.dialogService.open(DialogCaricaPermessoFase2, {
      data: {
        pratica: pratica,
      },
      header: header,
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            "Permesso ente pubblico per la pratica " +
            pratica.cui +
            " caricato con successo!",
          life: 3000,
        });
      }
    });
  }

  caricaFotoCPE(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogCaricaFoto, {
      data: {
        pratica: pratica,
      },
      header:
        "Caricamento FOTO del CPE della pratica " + pratica.cui.toUpperCase(),
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoFotoCPE) => {
      if (caricamentoFotoCPE && caricamentoFotoCPE.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Foto del cpe caricata con successo!",
          life: 3000,
        });
      }
    });
  }

  async scaricaFotoCPE(pratica: PraticaFlowdy2_Firestore, isMassivo: boolean) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/foto/`;
    try {
      const folderRef = ref(storage, folderPath);

      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        const filePath = folderPath + "/" + fileRef;
        const fileReference = ref(storage, filePath);
        const blobFile = await getBlob(fileReference);
        saveAs(blobFile, fileRef);
      }
      if (!isMassivo) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            pratica.numeroFotoCPEUploaded + " file scaricati con successo!",
          life: 3000,
        });
      }

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  caricaFile(pratica: PraticaFlowdy2_Firestore, tipoFile: string) {
    let header = "Caricamento ";
    if (tipoFile === "NT9") {
      header += "del pacchetto NT9";
    } else if (tipoFile === "FOTO ROUTER") {
      header += "della foto del ROUTER";
    } else {
      header += "ALTRI file";
    }

    //
    header += " della pratica " + pratica.cui.toUpperCase();
    if (tipoFile === "NT9") {
      this.ref = this.dialogService.open(DialogCaricaPacchettoNT9, {
        data: {
          pratica: pratica,
          tipoFile: tipoFile,
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    } else if (tipoFile === "FOTO ROUTER") {
      this.ref = this.dialogService.open(DialogCaricaFoto, {
        data: {
          pratica: pratica,
          tipoFile: "FOTO ROUTER",
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    } else {
      this.ref = this.dialogService.open(DialogCaricaAltriFile, {
        data: {
          pratica: pratica,
          tipoFile: tipoFile,
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }

    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        if (caricamentoDoc.numeroFileCaricati) {
          if (caricamentoDoc.numeroFileCaricati == 1) {
            this.messageService.add({
              severity: "success",
              summary: "",
              detail: "1 file caricato con successo!",
              life: 3000,
            });
          } else {
            this.messageService.add({
              severity: "success",
              summary: "",
              detail:
                caricamentoDoc.numeroFileCaricati +
                " file caricati con successo!",
              life: 3000,
            });
          }
        } else {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: tipoFile + " caricata con successo!",
            life: 3000,
          });
        }
      }
    });
  }

  async scaricaNT9FromFE(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const pathReferenceNT9 = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_3/file/nt9.zip",
    );

    const blobNT9 = await getBlob(pathReferenceNT9);
    saveAs(blobNT9, "nt9.zip");
    this.isLoadingResults = false;
  }
  async scaricaFotoRouter(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/foto/`;
    try {
      const folderRef = ref(storage, folderPath);

      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        const filePath = folderPath + "/" + fileRef;
        const fileReference = ref(storage, filePath);
        const blobFile = await getBlob(fileReference);
        saveAs(blobFile, fileRef);
      }

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  showPacchettoNT9Uploaded(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      //&& pratica.stato==='IN PROGETTAZIONE'
      (pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") &&
      pratica.nt9Uploaded
    ) {
      return true;
    }
    return false;
  }
  showFotoRouterUploaded(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (this.isImpresa || this.isPresidioSF) &&
      (pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" ||
        pratica.statoFlowdyFase3 === "CONSEGNATA" ||
        pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK SMARTFIBER" ||
        pratica.statoFlowdyFase3 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase3 === "IN CARICO PRESIDIO") &&
      pratica.fotoRouterUploaded
    ) {
      return true;
    }
    return false;
  }

  chiediEliminazioneTuttiFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    this.selectedPratica = pratica;
    if (tipoFile === "ALTRO") {
      this.showEliminaFileALTROConfirmation = true;
    } else if (tipoFile === "NT9") {
      this.showEliminaFileNT9Confirmation = true;
    } else if (tipoFile === "FOTO ROUTER") {
      this.showEliminaFileFotoRouterConfirmation = true;
    } else {
      this.showEliminaPlanimetriaConfirmation = true;
    }
  }

  async eliminataTuttiFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    const storage = getStorage();
    this.isLoadingResults = true;
    let folderPath = "";
    if (tipoFile === "ALTRO") {
      folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/altro`;
    } else if (tipoFile === "NT9") {
      folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/file`;
    } else if (tipoFile === "FOTO ROUTER") {
      folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/foto`;
    } else {
      folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/`;
    }

    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);
      const deletePromises = [];
      let deletedFileCount = 0;

      for (const fileItem of fileList.items) {
        // Itera direttamente sugli oggetti
        //  if (fileItem.name.startsWith(tipoFile)) {
        deletePromises.push(
          deleteObject(fileItem)
            .then(() => {
              deletedFileCount++;
            })
            .catch((deleteError) => {
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                detail: `Errore durante l'eliminazione del file ${fileItem.name}: ${deleteError.message}`,
                life: 10000,
              });
            }),
        );
        //   }
      }

      // Aspetta che tutti i file siano cancellati
      await Promise.all(deletePromises);

      // Aggiorna il documento Firestore solo dopo la cancellazione dei file
      const docRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);
      if (tipoFile === "ALTRO") {
        pratica.fileAltriUploadedFase3 = false;
      } else if (tipoFile === "NT9") {
        pratica.nt9Uploaded = false;
      } else if (tipoFile === "FOTO ROUTER") {
        pratica.fotoRouterUploaded = false;
      }

      await docRef.update(pratica);

      this.selectedPratica = null;
      // Mostra un messaggio con il numero di file eliminati e il tipo
      this.messageService.add({
        severity: "success",
        summary: "Eliminazione completata",
        detail: `${deletedFileCount} file sono stati eliminati con successo.`,
        life: 10000,
      });
      if (tipoFile === "ALTRO") {
        this.showEliminaFileALTROConfirmation = false;
      } else if (tipoFile === "NT9") {
        this.showEliminaFileNT9Confirmation = false;
      } else if (tipoFile === "FOTO ROUTER") {
        this.showEliminaFileFotoRouterConfirmation = false;
      }
      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "error",
        summary: "Attenzione!",
        detail: `Errore nel recupero dei file: ${error.message}`,
      });
    }
  }
  async eliminataPlanimetriaCaricata(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/`;

    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);
      const deletePromises = [];
      let deletedFileCount = 0;

      for (const fileItem of fileList.items) {
        // Itera direttamente sugli oggetti
        console.log(fileItem.name);
        if (fileItem.name.startsWith("PLANIMETRIA")) {
          deletePromises.push(
            deleteObject(fileItem)
              .then(() => {
                deletedFileCount++;
              })
              .catch((deleteError) => {
                this.messageService.add({
                  severity: "error",
                  summary: "Errore",
                  detail: `Errore durante l'eliminazione della planimetria: ${deleteError.message}`,
                  life: 10000,
                });
              }),
          );
        }
      }

      // Aspetta che tutti i file siano cancellati
      await Promise.all(deletePromises);

      // Aggiorna il documento Firestore solo dopo la cancellazione dei file
      const docRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);
      pratica.planimetriaUploaded = false;

      await docRef.update(pratica);
      this.showEliminaPlanimetriaConfirmation = false;
      this.selectedPratica = null;
      // Mostra un messaggio con il numero di file eliminati e il tipo
      this.messageService.add({
        severity: "success",
        summary: "Eliminazione completata",
        detail: `La planimetria è stata eliminata con successo.`,
        life: 10000,
      });

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "error",
        summary: "Attenzione!",
        detail: `Errore nel recupero dei file: ${error.message}`,
      });
    }
  }

  async scaricaFile(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
    isMassivo: boolean,
  ) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/file/`;
    try {
      const folderRef = ref(storage, folderPath);

      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        if (fileRef.startsWith(tipoFile)) {
          const filePath = folderPath + "/" + fileRef;
          const fileReference = ref(storage, filePath);
          const blobFile = await getBlob(fileReference);
          saveAs(blobFile, fileRef);
        }
      }
      const numeroFile: number =
        tipoFile === "PING_TEST"
          ? pratica.numeroFilePingtestUploaded
          : pratica.numeroFileSpeedtestUploaded;
      if (!isMassivo) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: numeroFile + " file scaricati con successo!",
          life: 3000,
        });
      }

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  annullaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.showAnnullaConsegnaConfirmation = true;
    this.selectedPratica = pratica;
  }
  confermaAnnullamentoConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService
      .annullaConsegnaFase3(this.selectedPratica.id)
      .subscribe({
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Annullamento consegna FASE 3 avvenuto con successo!",
            life: 5000,
          });
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di annullamento della consegna della FASE 3 della pratica",
          });
          this.isLoadingResults = false;
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
        },
        complete: () => {},
      });
  }

  async scaricaPermesso(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    let fileName =
      "pratiche/scuola/" +
      pratica.cui +
      "/IN/FASE_2/permesso/permesso_FASE2.pdf";
    let pathReferenceDoc = ref(storage, fileName);
    const blobFile = await getBlob(pathReferenceDoc);
    saveAs(blobFile, pratica.cui + "_permesso_fase2.pdf");
    this.isLoadingResults = false;
  }

  async scaricaDoc(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    let fileName =
      "pratiche/scuola/" +
      pratica.cui +
      "/IN/FASE_2/documentazione/" +
      pratica.cui;
    fileName += "_VERBALE_ATTIVAZIONE_FASE2.pdf";
    let pathReferenceDoc = ref(storage, fileName);
    const blobFile = await getBlob(pathReferenceDoc);
    saveAs(blobFile, pratica.cui + "_VERBALE_ATTIVAZIONE_FASE2.pdf");
    this.isLoadingResults = false;
  }

  async scaricaTuttaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    if (pratica.filePingTestUploaded) {
      this.scaricaFile(pratica, "PING_TEST", true);
    }
    if (pratica.fileSpeedTestUploaded) {
      this.scaricaFile(pratica, "SPEED_TEST", true);
    }
    if (pratica.fotoCPEUploaded) {
      this.scaricaFotoCPE(pratica, true);
    }
    if (pratica.fileVerbaleAttivazioneUploaded) {
      this.scaricaDoc(pratica);
    }

    if (pratica.servePermessoEntePubblico && pratica.permessoUploaded) {
      this.scaricaPermesso(pratica);
    }

    this.isLoadingResults = false;
  }

  importaInformazioni() {
    this.importID = uuidv4();
    this.csvbox_importer_comunicaInfoFase3.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_comunicaInfoFase3.openModal();
  }
  importaEsitiConsegna() {
    this.importID = uuidv4();
    this.csvbox_importer_comunicaEsitiConsegnaFase3.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_comunicaEsitiConsegnaFase3.openModal();
  }

  comunicaEsitoFase1(pratica: PraticaFlowdy2_Firestore, isApprovata: boolean) {
    if (isApprovata) {
      this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
        data: {
          pratica: pratica,
          fase: 1,
        },
        header:
          "Accettazione della FASE 3 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase1) => {
        if (bocciaturaFase1 && bocciaturaFase1.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Accettazione della FASE 3 della pratica comuinicata!",
            life: 3000,
          });
        }
      });
    } else {
      this.ref = this.dialogService.open(ComunicaBocciatura, {
        data: {
          pratica: pratica,
          fase: 1,
        },
        header:
          "Indica le moditivazioni della bocciatura della FASE 3 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase1) => {
        if (bocciaturaFase1 && bocciaturaFase1.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Bocciatura della FASE 3 della pratica comuinicata!",
            life: 3000,
          });
        }
      });
    }
  }

  assegnaODA(pratica: PraticaFlowdy2_Firestore) {
    const localizzazione: string =
      pratica.cui.split("-")[1] === "LIG"
        ? "LIGURIA"
        : pratica.cui.split("-")[1] === "PIE"
          ? "PIEMONTE"
          : "TOSCANA";
    this.isLoadingResults = true;
    this.odaService
      .getDisponibiliPerAzienda(
        pratica.idAzienda,
        pratica.bando,
        localizzazione,
      )
      .subscribe({
        next: (v) => {
          // this.logger.info(JSON.stringify(v));
          if (!v || v.length == 0) {
            this.isLoadingResults = false;
            this.messageService.add({
              life: 10000,
              severity: "warn",
              summary: "ATTENZIONE",
              detail:
                "Nessun ODA disponibile per l'azienda " +
                pratica.azienda +
                " ed il bando 1",
            });
          } else {
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(DialogAssegnaOdaFase1, {
              data: {
                pratica: pratica,
                listaOda: v,
              },
              header: "Assegna ODA alla pratica " + pratica.cui.toUpperCase(),
              width: "50%",
              height: "55%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confermaAssegnazioneODA) => {
              if (confermaAssegnazioneODA && confermaAssegnazioneODA.success) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "ODA assegnato con successo!",
                  life: 3000,
                });
                this.loadPratiche();
              }
            });
          }
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di recupero dell'oda da assegnare alla pratica",
          });
          this.isLoadingResults = false;
        },
        complete: () => {
          this.isLoadingResults = false;
        },
      });
  }
  openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    this.praticheService
      .getStoricoFase3(pratica.id)
      .subscribe((storicoPratica) => {
        this.isLoadingResults = false;
        if (storicoPratica && storicoPratica.length > 0) {
          this.ref = this.dialogService.open(StoricoPraticaComponent, {
            data: {
              pratica: pratica,
              storicoPratica: storicoPratica,
              fase: 3,
            },
            header: "Storico della FASE 3 della pratica " + pratica.cui,
            width: "50%",
            height: "85%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            detail: "La pratica non presenta STORICO",
          });
        }
      });
  }

  comunicaDataAppuntamento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogComunicaDataAppuntamentoFase2, {
      data: {
        pratica: pratica,
      },
      header: "Comunica data dell'appuntamento per la pratica " + pratica.cui,
      width: "50%",
      height: "30%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((dataAppuntamento) => {
      if (dataAppuntamento && dataAppuntamento.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Data appuntamento comunicata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }
  comunicaEsitoAppuntamento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogComunicaEsitoAppuntamentoFase2, {
      data: {
        pratica: pratica,
      },
      header:
        "Comunica l'esito dell'installazione del router per la pratica " +
        pratica.cui,
      width: "70%",
      height: "85%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((esitoInstallazione) => {
      if (esitoInstallazione && esitoInstallazione.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Esito installazione router comunicata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  checkIfDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      (pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
        pratica.statoFlowdyFase2 === "IN REWORK AZIENDA") &&
      pratica.fotoCPEUploaded &&
      pratica.fileVerbaleAttivazioneUploaded &&
      pratica.filePingTestUploaded &&
      pratica.numeroFilePingtestUploaded > 0 &&
      pratica.fileSpeedTestUploaded &&
      pratica.numeroFileSpeedtestUploaded > 0
    ) {
      return true;
    }

    return false;
  }

  loadPratiche() {
    this.isLoadingResults = false;
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let query;
    if (this.isPresidioTIM) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("statoFlowdyFase3", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .where("lotto", "==", this.filtroLottoPerFase)
              .where("statoFlowdyFase3", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase2");
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              //  .where("statoFlowdyFase1", "==", "PUBBLICATA")
              // .where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase3");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 FILTRO PER IN LAVORAZIONE ",
          );

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //.where("codiceStatoInfratelFase1", "!=", "1-6")
            //.where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase3");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              //  .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("numeroOda", "==", Number(this.filtroOda))
              //  .where("importoPagatoFase1", "==", null)
              // .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase3");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase2");
          }
        }
      } else {
        this.logger.info(
          "[FASE 3 BANDO 2] PRESIDIO TIM LOADING FASE 3 BANDO 2 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //  .where("codiceStatoInfratelFase1", "!=", "1-6")
            //   .where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase3");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase3");
        }
      }
    } else if (this.isImpresa) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .orderBy("codiceStatoInfratelFase3")
            .orderBy("cui");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase3",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("cui");
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .orderBy("cui");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER IN LAVORAZIONE ",
          );

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase2")
            .orderBy("cui");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase3",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase2");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase3",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroPratica) {
          this.logger.info(
            "[FASE 3 BANDO 1] LOADING PRATICHE FASE 2 FILTRO PER PRATICA " +
              this.filtroPratica,
          );
          query = collectionRef
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("cui", "==", this.filtroPratica);
        } else if (this.filtroStatoFlowdy) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO FLOWDY " +
              this.filtroStatoFlowdy,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
            //.where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            //.where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
        } else {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 SENZA FILTRI",
          );
          this.mostraPraticheCompletate = true;
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .orderBy("codiceStatoInfratelFase3");
        }
      } else {
        this.logger.info(
          "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase3",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .orderBy("codiceStatoInfratelFase3");
        }
      }
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDirigenteFirmaPacchetti ||
      this.isDemo
    ) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase3");
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase3");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 FILTRO PER IN LAVORAZIONE ",
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase3");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              // .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase3");
          }
        } else if (this.filtroPratica) {
          this.logger.info(
            "[FASE 3 BANDO 1] LOADING PRATICHE FASE 2 FILTRO PER PRATICA " +
              this.filtroPratica,
          );
          query = collectionRef.where("cui", "==", this.filtroPratica);
        } else if (this.filtroImpresa) {
          if (this.filtroStatoFlowdy) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("idAziendaFase3", "==", Number(this.filtroImpresa))
              .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
              .orderBy("codiceStatoInfratelFase3");
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER IMPRESA " +
                this.filtroImpresa,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("idAziendaFase3", "==", Number(this.filtroImpresa))
              .orderBy("codiceStatoInfratelFase3");
          }
        } else if (this.filtroStatoFlowdy) {
          //this.logger.info("[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO FLOWDY "+ this.filtroStatoFlowdy);
          if (this.filtroRegione) {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy +
                " E REGIONE " +
                this.filtroRegione,
            );
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("regione", "==", this.filtroRegione)
              .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
              .orderBy("codiceStatoInfratelFase3");
          } else {
            this.logger.info(
              "[FASE 3 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy,
            );
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
              .orderBy("codiceStatoInfratelFase3");
          }
        }
      } else {
        this.logger.info(
          "[FASE 3 BANDO 2] LOADING FASE 3 BANDO 2 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", "2-6")
            .orderBy("codiceStatoInfratelFase3");
        }
      }
    }

    onSnapshot(query, (qs) => {
      this.logger.info(
        "[FASE 3 BANDO 2] FASE 3 BANDO 2 CARICATE " + qs.docs.length,
      );

      this.pratiche = [];
      this.praticheSenzaEscludereLeKO = [];

      this.praticheFiltrate = [];
      this.isLoadingResults = false;
      qs.forEach((doc) => {
        let pratica = doc.data() as PraticaFlowdy2_Firestore;

        if (this.isPresidioTIM) {
          this.praticheSenzaEscludereLeKO.push(pratica);
          if (this.filtroStatoInfratel) {
            if (pratica.codiceStatoInfratelFase3 === this.filtroStatoInfratel) {
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
          } else {
            if (!this.mostraPraticheCompletate) {
              if (
                pratica.codiceStatoInfratelFase3 === "3-3" ||
                pratica.codiceStatoInfratelFase3 === "3-4"
              ) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              }
            } else {
              if (
                pratica.codiceStatoInfratelFase3 === "3-3" ||
                pratica.codiceStatoInfratelFase3 === "3-4" ||
                pratica.codiceStatoInfratelFase3 === "3-6"
              ) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              }
            }
          }
        } else {
          this.praticheSenzaEscludereLeKO.push(pratica);
          if (
            pratica.statoFlowdyFase1 !== "SOPRALLUOGO KO" &&
            pratica.codiceStatoInfratelFase1 === "1-6" &&
            pratica.codiceStatoInfratelFase2 === "2-6"
          ) {
            if (this.filtroStatoInfratel) {
              if (this.filtroStatoInfratel !== "3-6") {
                if (!this.mostraPraticheCompletate) {
                  if (
                    pratica.codiceStatoInfratelFase2 === "2-6" &&
                    pratica.codiceStatoInfratelFase3 !== "3-6"
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                } else {
                  if (
                    pratica.codiceStatoInfratelFase2 === "2-6" &&
                    (pratica.codiceStatoInfratelFase3 === "3-1" ||
                      pratica.codiceStatoInfratelFase3 === "3-2" ||
                      pratica.codiceStatoInfratelFase3 === "3-3" ||
                      pratica.codiceStatoInfratelFase3 === "3-4" ||
                      pratica.codiceStatoInfratelFase3 === "3-6")
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
              } else {
                if (
                  pratica.codiceStatoInfratelFase1 === "1-6" &&
                  pratica.codiceStatoInfratelFase2 === "2-6" &&
                  pratica.codiceStatoInfratelFase3 === "3-6"
                ) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }
            } else if (this.filtroStatoFlowdy) {
              if (pratica.statoFlowdyFase3 === this.filtroStatoFlowdy) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              }
            } else {
              if (!this.mostraPraticheCompletate) {
                if (
                  pratica.codiceStatoInfratelFase2 === "2-6" &&
                  pratica.codiceStatoInfratelFase3 !== "3-6"
                ) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              } else {
                if (
                  pratica.codiceStatoInfratelFase2 === "2-6" &&
                  (pratica.codiceStatoInfratelFase3 === "3-1" ||
                    pratica.codiceStatoInfratelFase3 === "3-2" ||
                    pratica.codiceStatoInfratelFase3 === "3-3" ||
                    pratica.codiceStatoInfratelFase3 === "3-4" ||
                    pratica.codiceStatoInfratelFase3 === "3-6")
                ) {
                  // this.logger.info("[FASE 3 BANDO 2] PRATICA "+ pratica.cui + " CODICE STATO INFRATEL FASE 3 "+ pratica.codiceStatoInfratelFase3);
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }
            }
          }
        }
      });
      this.filtraPratiche(null);
    });
  }

  onMostraCompletatiChange(newValue: boolean): void {
    this.logger.info(
      "[FASE 3 BANDO 2] ON MOSTRA COMPLETATI CHANGE " + newValue,
    );
    this.mostraPraticheCompletate = newValue;
    this.loadPratiche();
  }

  checkInviataAdInfratel(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.codiceStatoInfratelFase3 === "3-5" ||
      pratica.codiceStatoInfratelFase3 === "3-6"
    ) {
      return true;
    }
    return false;
  }

  filtraPratiche(event: any) {
    if (event && event.target) {
      this.praticheDT.filterGlobal(event.target.value, "contains");
    } else {
      if (
        this._filtroPratiche &&
        Object.keys(this._filtroPratiche).length !== 0
      ) {
        /*   if(this._filtroPratiche.statoPratica?.includes('APPROVATA')){
            this.mostraPraticheCompletate = true;
           // this.onMostraCompletatiChange(true);
          } */

        this.filterTabellaIsSet = true;
        this.praticheFiltrate = this.pratiche.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            const hasFiltroTipo =
              (this._filtroPratiche.tipo?.length ?? 0) > 0;
            if (hasFiltroTipo) {
              const tipoEff = pratica.tipoSedeEffettiva
                ? pratica.tipoSedeEffettiva.trim()
                : "";
              const tipoBase = pratica.tipoSede
                ? pratica.tipoSede.trim()
                : "";

              if (tipoEff && tipoEff.length > 0) {
                if (this._filtroPratiche.tipo.indexOf(tipoEff) === -1) {
                  return false;
                }
              } else if (tipoBase && tipoBase.length > 0) {
                if (this._filtroPratiche.tipo.indexOf(tipoBase) === -1) {
                  return false;
                }
              } else {
                return false;
              }
            }

            if (
              ((this._filtroPratiche.statoInfratel?.length ?? 0 > 0) &&
                this._filtroPratiche.statoInfratel.indexOf(
                  pratica.codiceStatoInfratelFase3,
                ) == -1) ||
              ((this._filtroPratiche.statoPratica?.length ?? 0 > 0) &&
                this._filtroPratiche.statoPratica.indexOf(
                  pratica.statoFlowdyFase3,
                ) == -1) ||
              ((this._filtroPratiche.regione?.length ?? 0 > 0) &&
                this._filtroPratiche.regione.indexOf(pratica.regione) == -1) ||
              //((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAzienda) == -1  )
              ((this._filtroPratiche.impresa?.length ?? 0 > 0) &&
                this._filtroPratiche.impresa.indexOf(
                  pratica.idAziendaFase3 || pratica.idAzienda,
                ) == -1)
            ) {
              return false;
            }

            return true;
          },
        );
      } else {
        this.praticheFiltrate = this.pratiche;
      }
    }
  }

  filtraPerStatoInfratel(statoInfratel: string) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(statoInfratel, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }

  filtraPerOda(numeroOda: number) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheDT.filterGlobal(numeroOda, "contains");
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }

  filtraPerBando(oda: OdaAtFirestore) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(oda.bando, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }
  filtraPerAzienda(azienda: String) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheDT.filterGlobal(azienda, "contains");
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }

  filtraPerLotto(lotto: string) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheFiltrate = this.pratiche.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            if (pratica.lotto === lotto) {
              return true;
            }

            return false;
          },
        );
        //this.praticheDT.filterGlobal(lotto, 'contains');
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }
  removeFilter() {
    if (
      this.filtroLotto ||
      this.filtroStatoInfratel ||
      this.filtroInLavorazione ||
      this.filtroOda ||
      this.filtroLottoPerFase ||
      this.filtroPratica ||
      this.filtroStatoFlowdy
    ) {
      this.location.replaceState("/pratiche-bando2/fase-3");

      this.filterIsSet = false;
      this.filtroLotto = null;
      this.filtroStatoInfratel = null;
      this.filtroInLavorazione = null;
      this.filtroOda = null;
      this.filtroLottoPerFase = null;
      this.filtroPratica = null;
      this.filtroStatoFlowdy = null;
      this.mostraPraticheCompletate = false;
      this.loadPratiche();
    } else {
      if (
        (this._filtroPratiche &&
          this._filtroPratiche.tipo &&
          this._filtroPratiche.tipo.length > 0) ||
        (this._filtroPratiche.statoInfratel &&
          this._filtroPratiche.statoInfratel.length > 0) ||
        (this._filtroPratiche.regione &&
          this._filtroPratiche.regione.length > 0) ||
        (this._filtroPratiche.statoPratica &&
          this._filtroPratiche.statoPratica.length > 0) ||
        (this._filtroPratiche.impresa &&
          this._filtroPratiche.impresa.length > 0)
      ) {
        this._filtroPratiche.tipo = [];
        this._filtroPratiche.statoInfratel = [];
        this._filtroPratiche.statoPratica = [];
        this._filtroPratiche.regione = [];
        this._filtroPratiche.impresa = [];
      }
      this.filterTabellaIsSet = false;
      this.praticheFiltrate = this.pratiche;
      this.praticheDT.clear();
    }
  }

  mostraPratiche(oda: OdaAtFirestore, fase: string) {}

  scaricaReportPratiche() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
    this.excelService.exportPraticheFase3ToExcel(
      this.pratiche,
      `pratiche_bando2_fase3_${formattedDate}.xlsx`,
      this.isImpresa,
    );
  }

  exportPraticheRespinteFase3() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
    this.excelService.exportPraticheRespinteFase3ToExcel(
      this.pratiche,
      `pratiche_respinte_fase3_${formattedDate}.xlsx`,
    );
    const count = this.pratiche.filter(
      (p) => p.statoFlowdyFase3 === "RESPINTA",
    ).length;
    this.messageService.add({
      severity: "success",
      summary: "Export completato",
      detail: `Esportate ${count} pratiche con stato RESPINTA`,
      life: 3000,
    });
  }

  exportLunghezzaIru2() {
    this.isLoadingResults = true;
    this.praticheService.exportLunghezzaIru2().subscribe({
      next: (blob: Blob) => {
        const today = new Date();
        const formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getFullYear()}`;
        saveAs(blob, `export-lunghezza-iru_${formattedDate}.xlsx`);
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "Export completato",
          detail: "File Excel lunghezza IRU2 scaricato con successo",
          life: 3000,
        });
      },
      error: (error) => {
        this.isLoadingResults = false;
        this.logger.error("Errore durante l'export lunghezza IRU2:", error);
        this.messageService.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'export della lunghezza IRU2",
          life: 10000,
        });
      },
    });
  }

  forzaStatoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogModificaStato, {
      data: {
        pratica: pratica,
        fase: 3,
      },
      header: "Cambio stato della Pratica " + pratica.cui,
      width: "50%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((statoUpdated) => {
      if (statoUpdated && statoUpdated.success) {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail:
            "Stato della pratica " + pratica.cui + " aggiornato con successo",
        });
      }
    });
  }

  setUserRole() {
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
    ) {
      this.isDirigenteFirmaVerbali = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
    ) {
      this.isDirigenteFirmaPacchetti = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }
}
